const messages = {
  es: {
    translations: {
      common: {
        close: "Cerrar",
      },
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado exitosamente! ¡Inicie sesión!",
          fail: "Error al crear usuario. Verifique los datos ingresados.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      platform: {
        title: "Estado de la plataforma",
        subtitle: "Recursos, base de datos y mantenimiento del servidor. Solo superadministrador.",
        refresh: "Actualizar",
        refreshed: "Medición actualizada",
        autoOn: "Auto: activado",
        autoOff: "Auto: desactivado",
        autoRefreshHint: "Vuelve a leer el estado cada 30 segundos",
        tabs: {
          overview: "Resumen",
          files: "Archivos",
          maintenance: "Mantenimiento",
          history: "Historial",
        },
      },
      reports: {
        title: "Informes",
        subtitle: "Cómo atiende tu equipo y qué tienes pendiente.",
        empty: "Sin datos en este periodo",
        noQueue: "Sin departamento",
        ago: "hace {{value}}",
        tabs: {
          summary: "Resumen",
          pending: "Pendientes",
          team: "Equipo",
          channels: "Canales y conexiones",
          tags: "Etiquetas",
          csat: "Satisfacción",
          kanban: "Kanban",
        },
        team: {
          title: "Rendimiento por agente",
          agent: "Agente",
          unassigned: "Sin asignar",
          rate: "% resueltas",
          sent: "Transf. enviadas",
          received: "Transf. recibidas",
          returned: "Devueltas",
          transfersNote: "Las transferencias se cuentan desde que se activó su registro (doc 0447); las anteriores no se reconstruyen.",
        },
        channels: {
          title: "Conexiones de la empresa",
          connection: "Conexión",
          channel: "Canal",
          statusLabel: "Estado",
          status: {
            CONNECTED: "Conectada",
            DISCONNECTED: "Desconectada",
            QRCODE: "Esperando QR",
            OPENING: "Conectando",
            PAIRING: "Emparejando",
            TIMEOUT: "Sin respuesta",
          },
        },
        tags: {
          title: "Etiquetas más aplicadas en el periodo",
          applied: "Veces aplicada",
          note: "Cuenta cada vez que se aplicó la etiqueta a un chat dentro del periodo.",
        },
        kanban: {
          noBoard: "Esta empresa no tiene un tablero Kanban configurado.",
          cardsNow: "Tarjetas en el tablero ahora",
          enteredPeriod: "Entradas en el periodo",
          slowest: "Etapa más lenta",
          slowestByStay: "Estancia media de {{value}}",
          slowestByAge: "Sus tarjetas llevan {{value}} de media",
          funnel: "Tarjetas por etapa (ahora)",
          detail: "Detalle del embudo",
          stage: "Etapa",
          now: "Ahora",
          avgAge: "Antigüedad media",
          entered: "Entradas",
          avgStay: "Estancia media",
          stuck: "Tarjetas detenidas hace más tiempo",
          contact: "Contacto",
          since: "Lleva",
          note: "Las entradas y la estancia por etapa se miden desde el 27/10/2026, cuando empezó a registrarse cada movimiento de tarjeta; antes no había historial. «Ahora» solo cuenta tarjetas de conversaciones no cerradas.",
        },
        csat: {
          short: "Valoración",
          avgRate: "Valoración media",
          answered: "Respuestas",
          answeredCount: "{{count}} respuestas",
          satisfied: "Satisfechos",
          satisfiedHint: "Valoraron con 4 o 5",
          unsatisfied: "Insatisfechos",
          unsatisfiedHint: "Valoraron con 1 o 2",
          responseRate: "Tasa de respuesta",
          responseRateHint: "{{answered}} de {{sent}} encuestas enviadas",
          distribution: "Reparto de valoraciones",
          byAgent: "Valoración por agente",
          enable: "Activar en Opciones",
          disabledTitle: "La encuesta de satisfacción está desactivada",
          disabledText: "Al cerrar una conversación, el cliente puede valorar la atención de 1 a 5. Actívala en Configuración › Opciones para empezar a medir la satisfacción de tu equipo.",
          disabledNotice: "La encuesta está desactivada: estas son valoraciones anteriores. Actívala en Configuración › Opciones para seguir midiendo.",
          noAnswersTitle: "Aún no hay valoraciones en este periodo",
          noAnswersText: "Se enviaron {{sent}} encuestas al cerrar conversaciones; las respuestas aparecerán aquí.",
        },
        filters: {
          period: "Periodo",
          from: "Desde",
          to: "Hasta",
          all: "Todos",
          queue: "Departamento",
          agent: "Agente",
          connection: "Conexión",
          presets: {
            today: "Hoy",
            "7d": "7 días",
            "30d": "30 días",
            custom: "Personalizado",
          },
        },
        kpi: {
          conversations: "Conversaciones",
          contacts: "{{count}} contactos distintos",
          resolved: "Resueltas",
          unattended: "Sin atender",
          unattendedHint: "Nadie las tomó",
          openNow: "En atención ahora",
          pendingNow: "En espera ahora",
          avgWait: "Espera media",
          avgWaitHint: "Desde que entra a la cola hasta que un agente la toma",
          avgResolution: "Resolución media",
          avgResolutionHint: "Desde que un agente la toma hasta que se cierra",
          avgFirstResponse: "Primera respuesta",
          avgFirstResponseHint: "Desde que el cliente escribe hasta que el agente le contesta",
        },
        charts: {
          overTime: "Conversaciones en el periodo",
          byChannel: "Por canal",
          byQueue: "Por departamento",
          topAgents: "Agentes con más conversaciones",
        },
        pending: {
          chats: "Chats en espera",
          leads: "Leads web sin atender",
          appointments: "Citas próximas (48 h)",
          none: "Nada pendiente",
          status: {
            pending: "Pendiente de confirmar",
            confirmed: "Confirmada",
            rescheduled: "Reprogramada",
            in_progress: "En curso",
          },
        },
      },
      authScreens: {
        heroTitle: "Todos tus chats, en un solo lugar",
        heroSubtitle: "WhatsApp, Instagram, Messenger y Telegram en una bandeja que tu equipo entiende desde el primer día.",
        mockMsg1: "¿Me confirma el horario de mañana?",
        mockMsg2: "Listo, ya realicé el pago",
        mockMsg3: "¿Tienen delivery?",
        loginTitle: "Bienvenido de nuevo",
        loginSubtitle: "Inicia sesión para seguir atendiendo.",
        loginButton: "Iniciar sesión",
        remember: "Recuérdame",
        noAccount: "¿No tienes una cuenta?",
        register: "Regístrate",
        signupTitle: "Crea tu cuenta",
        signupSubtitle: "Prueba gratis durante {{days}} días. Sin tarjeta.",
        signupButton: "Crear cuenta gratis",
        haveAccount: "¿Ya tienes cuenta?",
        signIn: "Inicia sesión",
        company: "Empresa",
        name: "Tu nombre",
        whatsapp: "WhatsApp",
        password: "Contraseña",
        acceptPrefix: "Acepto las",
        terms: "Condiciones de Uso",
        and: "y la",
        privacy: "Política de Privacidad",
        showPassword: "Mostrar u ocultar contraseña",
      },
      passwordRecovery: {
        forgotLink: "¿Olvidaste tu contraseña?",
        forgotTitle: "Recupera tu contraseña",
        forgotSubtitle: "Escribe el correo con el que entras. Te enviaremos un enlace para elegir una nueva.",
        email: "Correo electrónico",
        send: "Enviar enlace",
        sentTitle: "Revisa tu correo",
        sentBody: "Si ese correo tiene una cuenta, en unos minutos te llegará un enlace. Caduca en 30 minutos. Mira también en spam.",
        backToLogin: "Volver al inicio de sesión",
        resetTitle: "Elige una nueva contraseña",
        resetSubtitle: "Al guardarla se cerrarán las sesiones abiertas en todos tus dispositivos.",
        newPassword: "Nueva contraseña",
        confirmPassword: "Repite la contraseña",
        save: "Guardar contraseña",
        minLength: "Mínimo 8 caracteres",
        mismatch: "Las contraseñas no coinciden",
        doneTitle: "Contraseña actualizada",
        doneBody: "Ya puedes iniciar sesión con tu nueva contraseña.",
        goLogin: "Iniciar sesión",
        checking: "Comprobando el enlace…",
        invalidTitle: "Este enlace no sirve",
        invalidBody: "Puede que esté incompleto. Pide uno nuevo.",
        expiredTitle: "Este enlace caducó",
        expiredBody: "Los enlaces duran 30 minutos. Pide uno nuevo.",
        usedTitle: "Este enlace ya se usó",
        usedBody: "Cada enlace sirve una sola vez. Si necesitas cambiarla otra vez, pide uno nuevo.",
        requestNew: "Pedir un enlace nuevo",
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Iniciar sesión",
          register: " ¡Crea tu cuenta en solo unos clics!",
        },
        forgotPassword: "¿Olvidó su contraseña?",
      },
      plans: {
        title: "Planes",
        registerButton: "Registrar Plan",
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Filas",
          value: "Valor",
          campaigns: "Campañas",
          schedules: "Programaciones",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openAi: "Agente IA",
          integrations: "Integraciones",
          internalUse: "Uso Interno",
          internalPlan: "Plano Interno",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError: "No se pudo realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de Empresa",
          email: "Correo electrónico",
          phone: "Número de WhatsApp",
          plan: "Planes",
          status: "Estado",
          campaigns: "Campañas",
          dueDate: "Fecha de Vencimiento",
          recurrence: "Recurrencia",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada exitosamente!",
        },
        table: {
          name: "Nombre",
          email: "Correo electrónico",
          phone: "Teléfono",
          plan: "Planes",
          campaigns: "Campañas",
          status: "Estado",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError: "No se pudo realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
          registerRefreshPage:
            "Empresa registrada. Actualiza la página para ver los cambios.",
        },
        formTitle: {
          edit: "Editar Empresa",
          registerNew: "Registrar Nueva Empresa",
        },
        sections: {
          basicInfo: "Información Básica",
          configuration: "Configuración",
        },
        loadingPlans: "Cargando planes...",
        timezone: {
          label: "Zona Horaria",
          loading: "Cargando timezones...",
          loadingValue: "{{tz}} (cargando...)",
          fallbackCurrent: "{{tz}} (actual)",
          hint: "Zona horaria para visualización de fechas/horas en mensajes y tickets",
          ariaLabel: "Zona Horaria",
        },
        grid: {
          emptyTitle: "No hay empresas registradas",
          emptySubtitle: "Comienza registrando tu primera empresa",
        },
        tooltips: {
          editCompany: "Editar empresa",
        },
        buttons: {
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          addDueDate: "+ Vencimiento",
          user: "Usuario",
          registerCompany: "Registrar Empresa",
          saving: "Guardando...",
        },
          register: {
          formTitle: "Registrar Nueva Empresa",
          companyInfoSection: "Información de la Empresa",
          successTitle: "¡Empresa Registrada Exitosamente!",
          loadPlansError: "Error al cargar los planes disponibles",
          closingForm_one: "Cerrando el formulario en {{count}} segundo...",
          closingForm_other: "Cerrando el formulario en {{count}} segundos...",
          redirecting_one: "Redirigiendo a la pestaña de Empresas en {{count}} segundo...",
          redirecting_other: "Redirigiendo a la pestaña de Empresas en {{count}} segundos...",
          validation: {
            nameMin: "Nombre muy corto",
            nameMax: "Nombre muy largo",
            nameRequired: "Nombre requerido",
            passwordMin: "La contraseña debe tener al menos 8 caracteres",
            passwordMax: "Contraseña muy larga",
            passwordRequired: "Contraseña requerida",
            emailInvalid: "Email inválido",
            emailRequired: "Email requerido",
            phoneMin: "Número de teléfono muy corto",
            phoneRequired: "Número de WhatsApp requerido",
            planRequired: "Plan requerido",
          },
          buttons: {
            cancel: "Cancelar",
            back: "Volver",
            registering: "Registrando...",
            registered: "¡Registrado!",
          },
        },
        values: {
          yes: "Sí",
          no: "No",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semiannual: "Semestral",
          annual: "Anual",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Atenciones de hoy: ",
          },
        },
        filters: {
          filterType: "Tipo de filtro",
          dateFilter: "Filtro de fecha",
          periodFilter: "Filtro por período",
          selectPeriod: "Seleccionar período",
          initialDate: "Fecha inicial",
          finalDate: "Fecha final",
          start: "Inicio",
          end: "Fin",
          filter: "FILTRAR",
          period: "Período",
          noSelection: "Sin selección",
          last3Days: "Últimos 3 días",
          last7Days: "Últimos 7 días",
          last15Days: "Últimos 15 días",
          last30Days: "Últimos 30 días",
          last60Days: "Últimos 60 días",
          last90Days: "Últimos 90 días",
        },
        cards: {
          activeConnections: "Conexiones Activas",
          companies: "Empresas",
          inConversati: "En Conversación",
          inConversation: "En Conversación",
          waiting: "En Espera",
          finished: "Finalizadas",
          newContacts: "Nuevos Contactos",
          avgConversationTime: "Tiempo Promedio de Conversación",
          avgWaitTime: "Tiempo Promedio de Espera",
          totalConversationsByUsers: "Total de Conversaciones por Usuarios",
          totalAttendances: "Total de Atendimientos",
        },
        errors: {
          errorGettingConversationInfo: "Error al obtener información de conversaciones",
          parameterizeFilter: "Por favor, configure los filtros antes de buscar",
          loadData: "Error al cargar datos del dashboard",
        },
        table: {
          name: "Nombre",
          assessments: "Evaluaciones",
          avgServiceTime: "T.M. de Atención",
          status: "Estado (Actual)",
        },
      },
      connections: {
        title: "Conexiones",
        addDialog: {
          button: "Agregar conexión",
          title: "Agregar conexión",
          subtitle: "Elige por dónde atenderá tu equipo.",
          cancel: "Cancelar",
          notConfigured: "Sin configurar: actívalo en Configuración › Integraciones.",
          channels: {
            baileys: { title: "WhatsApp (código QR)", description: "Escanea un código QR con tu teléfono. Lista en un minuto." },
            waba: { title: "WhatsApp API oficial", description: "La API oficial de Meta, para alto volumen y plantillas." },
            facebook: { title: "Facebook Messenger", description: "Recibe los mensajes de tu página de Facebook." },
            instagram: { title: "Instagram", description: "Responde los mensajes directos de tu cuenta profesional." },
            telegram: { title: "Telegram", description: "Vincula tu cuenta de Telegram con un código QR." },
            email: { title: "Correo electrónico", description: "Lee y responde los correos de tu buzón de Gmail." },
            webform: { title: "Formulario web", description: "Una página de captación que convierte visitas en leads." },
          },
        },
        toasts: {
          deleted: "¡Conexión con WhatsApp eliminada exitosamente!",
          disconnected: "Sin conexión WhatsApp — {{name}}",
          connected: "WhatsApp conectado — {{name}}",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "¿Estás seguro? Deberás volver a leer el código QR.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
          restart: "Reiniciar conexiones",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión en WhatsApp",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet e inténtalo nuevamente, o solicita un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content:
              "Haz clic en el botón 'CÓDIGO QR' y lee el código QR con tu teléfono para iniciar sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          number: "Número",
          token: "Token",
          tokenEmpty: "Sin token (edite la conexión para generar uno)",
          aliasWa: "Alias WA",
          waName: "Nombre WA",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
        whatsappModal: {
          title: {
            add: "Agregar WhatsApp",
            edit: "Editar WhatsApp",
          },
          tabs: {
            general: "General",
            messages: "Mensajes",
            assessments: "Evaluaciones",
            integrations: "Integraciones",
            schedules: "Horario de expediente",
          },
          form: {
            name: "Nombre",
            default: "Predeterminado",
            sendIdQueue: "Fila",
            timeSendQueue: "Redireccionar a cola en X minutos",
            queueRedirection: "Redirección de cola",
            outOfHoursMessage: "Mensaje de fuera de expediente",
            queueRedirectionDesc: "Seleccione una fila para redirigir los contactos que no tienen fila",
            prompt: "Prompt",
            expiresTicket: "Cerrar chats abiertos después de X minutos",
            expiresInactiveMessage: "Mensaje de cierre por inactividad",
            greetingMessage: "Mensaje de saludo",
            complationMessage: "Mensaje de conclusión",
            timeToTransfer: "Transferir después de X (minutos)",
            transferQueue: "Cola de transferencia",
          },
          buttons: {
            okAdd: "Agregar",
            okEdit: "Guardar",
            cancel: "Cancelar",
          },
          success: "WhatsApp guardado con éxito.",
        },
      },
      qrCode: {
        message: "Escanea el código QR",
        waiting: "Generando código QR...",
      },
      securityAudit: {
        title: "Seguridad",
        subtitle: "Registro de seguridad de tu empresa: quién entró, cambios de permisos y contraseñas, tokens y alertas. Se guarda 180 días.",
        subtitleSuper: "Registro de seguridad de todas las empresas y de la plataforma, con las alertas. Se guarda 180 días.",
        empty: "Sin eventos para estos filtros.",
        loadMore: "Cargar más",
        platform: "Plataforma",
        filters: {
          action: "Evento",
          result: "Resultado",
          from: "Desde",
          to: "Hasta",
          all: "Todos",
        },
        columns: {
          date: "Fecha",
          action: "Evento",
          result: "Resultado",
          actor: "Quién",
          target: "Sobre qué",
          ip: "IP",
          company: "Empresa",
        },
        results: {
          ok: "Correcto",
          fallo: "Fallido",
          bloqueado: "Bloqueado",
        },
        actions: {
          login: "Inicio de sesión",
          logout: "Cierre de sesión",
          refresh: "Renovación de sesión",
          password_change: "Cambio de contraseña",
          password_reset_request: "Solicitud de recuperación de contraseña",
          user_create: "Alta de usuario",
          user_delete: "Baja de usuario",
          role_change: "Cambio de rol",
          permissions_change: "Cambio de permisos",
          token_regenerate: "Token de API generado",
          token_reveal: "Token de API consultado",
          platform_credentials_change: "Credenciales de plataforma cambiadas",
          token_auth: "Uso de token de API",
          rate_limit: "Freno por exceso de peticiones",
          export: "Exportación",
          audit_mode: "Ver como otro usuario",
          company_create: "Alta de empresa",
          company_delete: "Baja de empresa",
          security_alert: "ALERTA de seguridad",
        },
      },
      whatsappModal: {
        tokenShownOnce: "Token de la API de esta conexión: {{token}} — Cópialo ahora: por seguridad no se volverá a mostrar.",
        tokenKeepPlaceholder: "Déjalo vacío para conservar el actual",
        tokenSaved: "Guardado (termina en {{preview}}). Escribe uno nuevo solo si quieres cambiarlo.",
        tokenReveal: "Mostrar token",
        tokenCurrent: "Token actual (para tus integraciones)",
        tokenCopy: "Copiar",
        tokenCopied: "Token copiado",
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de expediente",
        },
        form: {
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Fila",
          timeSendQueue: "Redireccionar a cola en X minutos",
          queueRedirection: "Redirección de cola",
          outOfHoursMessage: "Mensaje de fuera de expediente",
          queueRedirectionDesc: "Seleccione una fila para redirigir los contactos que no tienen fila",
          prompt: "Prompt",
          expiresTicket: "Cerrar chats abiertos después de X minutos",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          timeToTransfer: "Transferir después de X (minutos)",
          transferQueue: "Cola de transferencia",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "Contacto eliminado con éxito!",
          deletedAll: "Todos los contactos eliminados con éxito!",
          exported: "Contactos exportados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar agenda de contactos telefónico",
          exportTitle: "Exportar contactos",
          deleteMessage: "¿Seguro que desea eliminar este contacto? Se perderán todos los tickets relacionados.",
          deleteAllMessage: "¿Seguro que desea eliminar todos los contactos? Se perderán todos los tickets relacionados.",
          exportMessage: "¿Está seguro que desea exportar los contactos seleccionados?",
          exportAllMessage: "¿Está seguro que desea exportar todos los contactos?",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
          importAgendaMessage: "Existen {count} contactos en su agenda ¿Desea importarlos?",
          titleExportAll: "Exportar todos los contactos",
          titleExportOne: "Exportar 1 contacto",
          titleExportMany: "Exportar {{count}} contactos",
          titleDeleteOne: "Eliminar 1 contacto",
          titleDeleteMany: "Eliminar {{count}} contactos",
          exportConfirmAll:
            "¿Está seguro que desea exportar todos los contactos?",
          exportConfirmMany:
            "¿Está seguro que desea exportar {{count}} contacto(s)?",
          deleteSelectedMany:
            "¿Seguro que desea eliminar {{count}} contacto(s)? Se perderán todos los tickets relacionados.",
        },
        tooltips: {
          importAgendaDisabled:
            "Esta funcionalidad está temporalmente deshabilitada. Baileys 6.7.21 no soporta la obtención directa de contactos. Se habilitará nuevamente cuando haya una versión compatible de Baileys.",
        },
        buttons: {
          import: "IMPORTAR AGENDA",
          importSheet: "Importar",
          add: "Agregar",
          export: "Exportar",
          delete: "BORRAR",
          deleteAll: "Eliminar Todos Contactos",
          downloadTemplate: "Descargar Plantilla",
        },
        table: {
          profile: "Perfil",
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          lastInteraction: "Última Interacción",
          status: "Estado",
          actions: "Acciones",
        },
        pagination: {
          rowsPerPage: "Registros por página:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        badge: {
          contact: "contacto",
          contacts: "contactos",
        },
        messages: {
          selectToExport: "Para exportar contactos necesitas seleccionar al menos 1 contacto",
          processingExport: "Procesando {count} contactos... Esto puede tomar unos segundos.",
          exportSuccess: "Contactos exportados exitosamente",
          exportError: "Error al exportar los contactos. Intente nuevamente.",
          checkingAgenda: "Verificando agenda de contactos...",
          importingContacts: "Importando {count} contactos... Esto puede tomar varios minutos.",
          importSuccess: "Contactos importados exitosamente",
          importError: "Error al importar los contactos. Intente nuevamente.",
          agendaEmpty: "No se encontraron contactos en la agenda del teléfono.",
          importInvalidResponse: "Respuesta inválida del servidor",
          importErrorGeneric: "Error al importar contactos",
          templateDownloadSuccess: "Plantilla descargada correctamente",
          templateDownloadError: "Error al descargar la plantilla",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral se iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Región de Voz",
        },
        success: "Prompt guardado con éxito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          cancelUpper: "CANCELAR",
          expand: "AMPLIAR",
          saveChanges: "Guardar cambios",
        },
        sections: {
          provider: "Configuración de proveedor de IA",
          api: "Configuración de API",
          basic: "Información básica",
          advanced: "Configuración avanzada",
          media: "Archivos multimedia",
          workMode: "Modo de trabajo",
        },
        providerInfo: {
          title: "Configuración de proveedor de IA",
          body1:
            "Selecciona el proveedor de inteligencia artificial que utilizará este prompt. Cada proveedor ofrece distintos modelos y capacidades según tus necesidades.",
          body2:
            "Proveedores disponibles: OpenAI oficial, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi y OpenRouter. Cada opción requiere la API key de ese proveedor (OpenRouter usa sk-or-v1-…).",
        },
        mustValidateBeforeSave:
          "Debes validar la API Key y el proveedor antes de guardar. Usa el botón «Probar conexión».",
        mustValidateBeforeSaveWithStored:
          "Si cambiaste de proveedor o pegaste nueva clave, valida con «Probar conexión». Para solo editar texto u opciones, deja vacía la clave y mantén el mismo proveedor.",
        validation: {
          nameRequired: "El nombre es obligatorio",
          apiKeyRequired: "La API Key es obligatoria",
          promptRequired: "El prompt es obligatorio",
          maxTokensRequired: "Los tokens máximos son obligatorios",
          temperatureRequired: "La temperatura es obligatoria",
          maxMessagesRequired: "Los mensajes máximos son obligatorios",
        },
        fields: {
          aiProvider: "Proveedor de IA",
          promptName: "Nombre del prompt",
          promptNameHelper: "Ej.: Bot de soporte, asistente de ventas…",
          promptNamePlaceholder: "Ej.: Bot de soporte",
          mainPrompt: "Prompt principal",
          mainPromptHelper: "Define cómo debe comportarse la IA. Sé específico y claro.",
          mainPromptPlaceholder:
            "Eres un asistente de soporte técnico. Responde de manera profesional y útil…",
          charCount: "Cantidad de caracteres: {{count}}",
          temperature: "Temperatura",
          temperatureHelper: "0.0 = determinístico, 2.0 = muy creativo",
          maxTokens: "Máximo tokens",
          maxTokensHelper: "Límite de tokens en la respuesta",
          maxMessages: "Máximo mensajes",
          maxMessagesHelper: "Mensajes en el historial",
          queueOptional: "Departamentos (opcional)",
          noQueue: "Sin departamento",
          workModeLabel: "Modo de trabajo",
          workModeLayers: "Capas contextuales",
          workModePdfs: "Documentos PDF",
          workModeHintLayers: "Usa capas contextuales activadas por palabras clave",
          workModeHintPdfs: "Sube documentos PDF para que la IA aprenda de ellos",
        },
        apiTest: {
          validating: "Validando…",
          validated: "✅ Validado",
          validatedHelper: "✅ API Key validada correctamente",
          storedKeyMaskPlaceholder:
            "Pegue aquí solo si quiere cambiar la clave (al abrir editar ya se muestra la guardada).",
          storedKeyHelper:
            "Al editar este prompt verás la API Key cargada desde el servidor. Déjela tal cual para conservarla o sustituya el texto por una nueva clave. Use «Probar conexión» para validar.",
          testConnection: "Probar conexión",
          enterApiKeyFirst: "Por favor ingresa una API Key primero",
          selectProviderFirst: "Por favor selecciona un proveedor primero",
          keyTooShortToast: "La API Key parece ser muy corta. Verifica que sea correcta.",
          keyTooShort: "API Key muy corta",
          connectionSuccess: "Conexión exitosa",
          validationFailed: "Error de validación",
          validateError: "Error validando API",
          unknownError: "Error desconocido",
        },
        media: {
          savePromptFirst: "Primero debes guardar el prompt",
          savePromptFirstToast: "Primero debes guardar el prompt",
          unknownFileType: "Error: tipo de archivo no reconocido",
          noFilesSelected: "No se seleccionaron archivos",
          unexpectedError: "Error inesperado: {{message}}",
          fileDeleted: "Archivo eliminado correctamente",
          deleteFileError: "Error al eliminar archivo: {{message}}",
          maxSixFiles: "Máximo 6 archivos por prompt",
          urlAdded: "URL externa agregada correctamente",
          urlAddError: "Error al agregar URL: {{message}}",
          addUrl: "Agregar URL",
          uploadFile: "Subir archivo",
          hintFiles: "📎 Puedes agregar hasta 6 archivos multimedia (imágenes, videos, audios, documentos)",
          hintLimits: "📏 Límites: imágenes/audios 10 MB, videos/documentos 15 MB",
          hintSyntax:
            "💡 Usa la sintaxis [MEDIA: nombrearchivo.ext] en tu prompt para referenciar archivos",
          filesCount: "{{current}}/6 archivos agregados",
          uploadSuccessCount: "{{count}} archivo(s) agregado(s) correctamente",
          maxSixWithCounts:
            "Máximo 6 archivos por prompt. Ya tienes {{current}} y estás intentando agregar {{adding}}. Solo puedes agregar {{remaining}} más.",
          maxSixNoMore:
            "Máximo 6 archivos por prompt. Ya tienes {{count}} archivos. No se pueden agregar más.",
          someRejected: "Algunos archivos no se pudieron agregar: {{list}}",
          fileTooBig: "{{name}}: excede {{maxMb}}MB",
          uploadPartial:
            "{{uploaded}} archivo(s) agregado(s), {{failed}} fallaron: {{names}}",
          uploadFailedDetail: "Error al subir archivos: {{details}}",
          uploadNone:
            "No se pudo subir ningún archivo. Verifica la consola para más detalles.",
        },
        urlDialog: {
          title: "Agregar URL externa",
          urlLabel: "URL del archivo",
          urlPlaceholder: "https://ejemplo.com/archivo.jpg",
          captionLabel: "Descripción (opcional)",
          captionPlaceholder: "Descripción del archivo",
          hintPublic: "💡 Asegúrate de que la URL sea accesible públicamente",
          add: "Agregar",
          close: "Cerrar",
        },
        expanded: {
          confirmClose:
            "¿Deseas guardar los cambios antes de cerrar?",
          title: "Editor ampliado — prompt principal",
          unsavedChip: "Cambios sin guardar",
          intro:
            "Edita tu prompt con más espacio. Las referencias a archivos multimedia [MEDIA: nombrearchivo.ext] aparecerán resaltadas en la vista previa.",
          editorPlaceholder: "Escribe tu prompt aquí…",
          charCount: "Cantidad de caracteres: {{count}}",
          previewTitle: "Vista previa (con resaltado):",
          toastSaved: "Prompt actualizado correctamente",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteTitleNamed: "¿Eliminar el prompt «{{name}}»?",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
        listPage: {
          title: "Prompts de IA",
          addButton: "Agregar prompt",
          providersTitle: "Proveedores de IA disponibles",
          providersIntro:
            "Selecciona el proveedor de inteligencia artificial que mejor se adapte a tus necesidades. Disponemos de proveedores oficiales: OpenAI, Gemini, Grok, Deepseek® y OpenRouter.",
          providersApiKey:
            "Cada proveedor ofrece distintos modelos y capacidades. Asegúrate de tener una API Key válida para el proveedor seleccionado.",
          tablePromptName: "Nombre del prompt",
          tableProvider: "Proveedor IA",
          tableMaxTokens: "Máximo tokens",
          tableTemperature: "Temperatura",
          tableMaxMessages: "Máximo mensajes",
          tableActions: "Acciones",
          tokensChip: "{{count}} tokens",
          tooltipEdit: "Editar prompt",
          tooltipDelete: "Eliminar prompt",
        },
      },
      contactModal: {
        notes: {
          title: "Observaciones del Contacto",
          success: "Observación agregada exitosamente",
          deleted: "Observación eliminada exitosamente",
          deleteTitle: "Eliminar Observación",
          deleteMessage: "¿Desea realmente eliminar esta observación?",
        },
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          whatsapp: "Conexión Origen: "
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar departamento",
          edit: "Editar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
        },
        tabs: {
          queueData: "Datos del departamento",
          serviceHours: "Horario de servicio",
        },
        automation: {
          title: "Automatización de procesos",
          intro:
            "Puedes automatizar conversaciones con prompts personalizados, flujos de trabajo (FlowBuilder), integraciones externas o un chatbot con menús de opciones: el contacto elige con botones en el chat, no escribe en modo libre. Solo puede estar activa una de las cuatro opciones a la vez; ninguna es obligatoria.",
        },
        form: {
          name: "Nombre",
          departmentName: "Nombre del departamento",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
          enableGreeting: "Activar saludo",
          greetingEnabledOn: "Habilitado — se enviará el mensaje de bienvenida.",
          greetingEnabledOff: "Desactivado — no se muestra ni envía saludo.",
          greetingRequired: "Si activa el saludo, debe escribir el mensaje.",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de la cola (Bot)",
          integrationId: "Integración",
          noIntegration: "Sin integración",
          prompt: "Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          attach: "Adjuntar archivo",
        },
        toasts: {
          deleted: "Archivo eliminado correctamente.",
        },
        schedules: {
          title: "Agendamientos",
          confirmationModal: {
            deleteTitle: "¿Estás seguro de que quieres eliminar este Agendamiento?",
            deleteMessage: "Esta acción no se puede deshacer.",
          },
          table: {
            contact: "Contacto",
            body: "Mensaje",
            sendAt: "Fecha de Agendamiento",
            sentAt: "Fecha de Envío",
            status: "Estado",
            actions: "Acciones",
          },
          buttons: {
            add: "Nuevo Agendamiento",
          },
          toasts: {
            deleted: "Agendamiento eliminado con éxito.",
          },
          saveSuccess: "Horarios guardados correctamente.",
          saveButton: "Guardar horarios",
        },
      },
      schedules: {
        form: {
          weekday: "Día de la semana",
          startTime: "Hora de inicio",
          endTime: "Hora de fin",
          save: "Guardar horarios",
        },
      },
      userModal: {
        tabs: {
          user: "Usuario",
          extra: "Adicional"
        },
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          emailSignature: "Firma de correo",
          emailSignatureHint: "Va al pie de tus correos cuando «Firmar» está activo. Vacía, se usa tu nombre.",
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          profile: "Perfil",
          superAdmin: "Superadministrador",
          queuesFromTeam: "Los departamentos los define su equipo. Se conservan los individuales por si se desactiva el trabajo por equipos.",
          whatsappHint: "Conexión por la que saldrán los tickets que este usuario cree a mano. Vacío = la predeterminada de la empresa.",
                    superAdminHint: "Su rol se otorga al instalar el producto y no se cambia desde aquí.",
          roleUnavailable: "Rol no disponible en esta empresa",
          whatsapp: "Conexión Predeterminada",
          language: "Idioma del panel",
          allTicket: "Ver Tickets Sin Asignar",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Agendamiento",
          edit: "Editar Agendamiento",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          cancelMeeting: "Cancelar reunión",
          exit: "Salir",
        },
        selectConnectionPlaceholder: "Seleccione una conexión",
        bodyCharCounter: "{{current}}/500 caracteres",
        success: "Agendamiento guardado con éxito.",
        toasts: {
          deleted: "Archivo eliminado con éxito.",
          meetingCancelled: "Reunión cancelada exitosamente",
          updated: "✅ Agendamiento actualizado correctamente",
          created: "✅ Agendamiento creado correctamente",
          noDataSave: "❌ Error: No hay datos para guardar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar archivo",
          deleteMessage: "¿Estás seguro de que quieres eliminar este archivo?",
        },
        cancelMeetingTitle: "Cancelar Reunión",
        cancelMeetingMessage:
          "¿Está seguro que desea cancelar esta reunión? Se enviará un mensaje de cancelación al contacto.",
        confirmScheduleTitle: "¿Está seguro de agendar la cita?",
        confirmScheduleDate: "Fecha y Hora:",
        confirmScheduleContact: "Contacto:",
        confirmScheduleWhatsapp: "Conexión:",
        confirmScheduleMessage: "Mensaje:",
        confirmScheduleQuestion:
          "¿Confirma que desea agendar esta cita con los datos mostrados?",
        validationErrorTitle: "❌ Error de validación",
        understood: "Entendido",
        validationGeneric: "Error al validar el agendamiento",
        contactNotFound: "Contacto no encontrado",
        whatsappNotFound: "Conexión no encontrada",
        dialogStatusErro: "Error de envío",
        dialogStatusPrefix: "Mensaje",
        autocompleteNoContacts: "No se encontraron contactos",
        searchContactLabel: "Escribe para buscar contactos",
        searchContactPlaceholder: "Clic aquí para ver contactos disponibles",
        attachFile: "Adjuntar archivo",
        validation: {
          required: "Obligatorio",
          invalidDateTime: "❌ Fecha/hora inválida",
          pastDateTime:
            "❌ No puedes agendar para una fecha/hora pasada. Hora actual: {{now}}",
          minTenMinutes:
            "❌ El tiempo mínimo para agendar es 10 minutos. Hora más temprana permitida: {{min}}",
          maxOneYear: "❌ No puedes agendar para más de 1 año en el futuro",
          febMaxDays: "❌ Febrero no puede tener más de 29 días",
          feb29Leap: "❌ 29 de febrero solo existe en años bisiestos",
          month30: "❌ El mes {{month}} no puede tener más de 30 días",
          bodyShort: "Mensaje muy corto",
          messageMax: "❌ El mensaje no puede exceder 500 caracteres",
          messageMinChars: "❌ El mensaje debe tener al menos 3 caracteres",
          messageMinValid:
            "❌ El mensaje debe contener al menos 2 caracteres válidos",
          allFieldsRequired:
            "❌ Todos los campos son obligatorios: contacto, conexión, mensaje y fecha/hora",
        },
        connectionFallback: "Conexión {{id}}",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
          namePlaceholder: "Ej: Atención, Cliente, Interesado...",
          pickColorTitle: "Seleccionar color",
          kanbanLabel: "Usar en Kanban",
          kanbanHint:
            "Las etiquetas con Kanban activado aparecerán como columnas en el tablero Kanban",
        },
        validation: {
          nameMin: "Nombre demasiado corto",
          required: "Obligatorio",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      schedulePage: {
        moduleTitle: "Agenda de Citas",
        scheduledTotal: "{{count}} agendamientos",
        title: "Agendamientos ({{count}})",
        notAvailable: "N/D",
        viewTable: "Vista tabla",
        viewCalendar: "Vista calendario",
        newButton: "Nuevo Agendamiento",
        table: {
          date: "Fecha",
          time: "Hora",
          contact: "Contacto",
          connection: "Conexión",
          message: "Mensaje",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          error: "Error",
          cancelled: "Cancelado",
          sent: "Enviado",
          overdue: "Vencido",
          pending: "Pendiente",
        },
        cancelMeetingTitle: "¿Cancelar reunión?",
        cancelScheduleTitle: "¿Cancelar agendamiento?",
        cancelMeetingMessage:
          "¿Estás seguro de que deseas cancelar esta reunión? Se eliminarán todos los recordatorios asociados.",
        cancelScheduleMessage:
          "¿Estás seguro de que deseas cancelar este agendamiento? Se enviará un mensaje de cancelación al contacto.",
        toastMeetingCancelled: "Reunión cancelada exitosamente",
        toastScheduleCancelled: "Agendamiento cancelado exitosamente",
        deleteTitleAlreadyCancelled: "Ya cancelado",
        deleteTitleCancel: "Cancelar agendamiento",
        calendar: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          allDay: "Día completo",
          week: "Semana",
          work_week: "Agendamientos",
          day: "Día",
          month: "Mes",
          previous: "Anterior",
          next: "Siguiente",
          yesterday: "Ayer",
          tomorrow: "Mañana",
          today: "Hoy",
          agenda: "Agenda",
          noEventsInRange: "No hay agendamientos en este período.",
          showMore: "+{{total}} más",
        },
      },
      appointmentsModule: {
        page: {
          moduleTitle: "Agenda de Citas",
          newAppointment: "Nueva cita",
          tabs: {
            dashboard: "Dashboard",
            calendar: "Calendario",
            history: "Historial",
            webLeads: "Solicitudes web",
            settings: "Configuración",
          },
          accessDeniedTitle: "No tienes acceso al módulo Agenda",
          accessDeniedP1:
            "Debes estar vinculado como profesional/instructor en Agenda > Configuración > Equipo, o ser administrador.",
          accessDeniedP2:
            "Flujo: Registrar primero en Usuarios → luego vincular como Professional en Equipo.",
          goHome: "Ir al inicio",
          checkingAccess: "Verificando acceso…",
        },
        status: {
          all: "Todos",
          pending: "Pendiente",
          confirmed: "Confirmada",
          rescheduled: "Reprogramada",
          in_progress: "En curso",
          completed: "Completada",
          no_show: "No asistió",
          cancelled: "Cancelada",
        },
        webLeads: {
          loading: "Cargando solicitudes…",
          empty: "Todavía no ha llegado ninguna solicitud desde la web",
          emptyHint:
            "En cuanto alguien envíe el formulario de la página, aparecerá aquí sin necesidad de recargar.",
          countLine: "{{count}} solicitudes · {{pending}} sin revisar",
          autoRefreshHint: "Se actualiza solo cada 10 segundos.",
          reload: "Recargar",
          filterAll: "Todas",
          statusNueva: "Nueva",
          statusVista: "Vista",
          statusDescartada: "Descartada",
          justNow: "Hace unos segundos",
          minutesAgo: "Hace {{count}} min",
          colReceived: "Recibida",
          colName: "Nombre",
          colPhone: "WhatsApp",
          colPreferred: "Fecha preferida",
          colService: "Servicio",
          colSource: "Origen",
          colStatus: "Estado",
          colActions: "Acciones",
          phoneConfirmedWhatsapp: "Confirmado: WhatsApp real verificó que este número existe",
          phoneUnchecked: "Formato aceptado, pero todavía sin verificar contra WhatsApp real",
          phoneInvalidFormat:
            "No se pudo interpretar como un número de WhatsApp válido — revisa cómo lo escribió el visitante",
          phoneNoWhatsapp:
            "WhatsApp real confirmó que ese número no existe — el lead no se convirtió en ticket",
          tableAria: "Solicitudes recibidas desde la web",
          markSeen: "Marcar como vista",
          discard: "Descartar",
          seeContact: "Ver ficha del contacto",
          seePayload: "Ver datos recibidos",
          payloadTitle: "Datos recibidos del formulario",
          payloadHint: "Cuerpo original tal como llegó, sin modificar.",
          close: "Cerrar",
          deleteLead: "Eliminar (borrado real, solo admin)",
          deleteConfirmTitle: "¿Eliminar esta solicitud para siempre?",
          deleteConfirmMessage:
            "Vas a borrar la solicitud de {{name}} por completo — no queda como \"Descartada\", desaparece del todo. Úsalo solo para datos de prueba, nunca para un lead real.",
          deleteSuccess: "Solicitud eliminada.",
        },
        calendar: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          today: "Hoy",
          previous: "Anterior",
          next: "Siguiente",
          month: "Mes",
          week: "Semana",
          day: "Día",
          agenda: "Agenda",
          noEventsInRange: "No hay citas en este período.",
          noName: "Sin nombre",
          serviceFallback: "Servicio",
        },
        dashboard: {
          wd0: "Lun",
          wd1: "Mar",
          wd2: "Mié",
          wd3: "Jue",
          wd4: "Vie",
          wd5: "Sáb",
          wd6: "Dom",
          kpiWeek: "Sesiones esta semana",
          kpiPending: "Pendientes de confirmar",
          kpiToday: "Sesiones hoy",
          kpiRate: "Tasa de asistencia (30 días)",
          chartTitle: "Sesiones por día — {{month}}",
          todayTitle: "Sesiones de hoy",
          todayEmpty: "No hay sesiones programadas para hoy",
          todayLine: "{{time}}: {{contact}} — {{service}}",
          professionalPrefix: "Profesional:",
          upcomingTitle: "Próximas sesiones",
          upcomingEmpty: "No hay sesiones programadas en los próximos 30 días",
          chartConfirmed: "Confirmadas",
          chartPending: "Pendientes",
          chartCancelled: "Canceladas",
        },
        historial: {
          loading: "Cargando historial…",
          empty: "No hay citas con los filtros aplicados",
          emptyHint:
            "Ajusta las fechas o el estado en el encabezado para ver más resultados",
          countOrder: "{{count}} citas · Orden: {{order}}",
          orderAsc: "próximas primero",
          orderDesc: "más recientes primero",
          changeOrder: "Cambiar orden",
          edit: "Editar",
          editReschedule: "Editar / Reagendar",
          editAria: "Editar cita",
          tableAria: "Historial de citas",
          colDate: "Fecha",
          colTime: "Hora",
          colContact: "Contacto",
          colService: "Servicio",
          colProfessional: "Profesional",
          colStatus: "Estado",
          colActions: "Acciones",
          rowsPerPage: "Filas por página:",
          rowsPerPageShort: "Filas:",
          displayedRows: "{{from}}-{{to}} de {{count}}",
        },
        config: {
          firstTimeTitle: "¿Primera vez configurando Agenda?",
          firstTimeSubtitle:
            "Configura perfil, servicios, equipo y horarios en pocos pasos.",
          firstTimeCta: "Comienza aquí",
          activeProfileTitle: "Perfil activo: {{name}}",
          activeProfileSubtitle:
            "Modifica cualquier aspecto de la configuración inicial.",
          cardPerfilTitle: "Tipo de negocio / perfil",
          cardPerfilDesc:
            "Define si eres Belleza, Comercial, Salud, Educación o Técnico. Afecta vocabulario y columnas Kanban.",
          cardServiciosTitle: "Servicios / Programas",
          cardServiciosDesc:
            "Catálogo de servicios, materias o programas con duración y precio.",
          cardEquipoTitle: "Equipo de trabajo",
          cardEquipoDesc:
            "Usuarios del equipo vinculados a la Agenda. Cada uno puede gestionar y confirmar citas.",
          cardHorariosTitle: "Horarios de atención",
          cardHorariosDesc: "Días, horarios y duración de slots por día.",
          secuenciasTitle: "Secuencias automáticas de mensajes",
          secuenciasSubtitle: "Se envían automáticamente según el estado y tiempo de la cita.",
          secuenciasLoading: "Cargando secuencias…",
          secuenciasEmpty: "No hay secuencias configuradas.",
          secuenciasToastOn: "Secuencia activada.",
          secuenciasToastOff: "Secuencia desactivada.",
          secuenciasAddBtn: "Agregar",
          seqDialogCreateTitle: "Nueva secuencia",
          seqDialogEditTitle: "Editar secuencia",
          seqDialogDeleteTitle: "¿Eliminar secuencia?",
          seqDialogDeleteDesc: "Esta acción no se puede deshacer.",
          seqDialogDeleteOk: "Eliminar",
          seqToastCreated: "Secuencia creada.",
          seqToastUpdated: "Secuencia actualizada.",
          seqToastDeleted: "Secuencia eliminada.",
          horariosSlotLabel: "Slot (intervalo por defecto)",
          horariosSave: "Guardar horarios",
          horariosSaving: "Guardando…",
          horariosToastOk: "Horarios de atención actualizados.",
          horariosClosed: "Cerrado",
          horariosFrom: "Desde",
          horariosTo: "Hasta",
          cardSecuenciasTitle: "Secuencias Notificaciones",
          cardSecuenciasDesc:
            "Recordatorios automáticos que se envían según el estado y el tiempo de la cita.",
          cardAgenteIaTitle: "Secuencia Agente IA",
          cardAgenteIaDesc:
            "Mensajes que se envían al confirmar, cancelar o reagendar una cita. Configura el agente conversacional.",
          agentSeqSubtitle:
            "Plantillas editables para los eventos de ciclo de vida de la cita (confirmación, cancelación, reagendamiento).",
          equipoIntro:
            "Vincula cada miembro del equipo con un usuario del sistema para que pueda gestionar y confirmar citas en la Agenda.",
          equipoAddBtn: "+ Agregar",
          equipoConfigureBtn:
            "Configurar equipo (nombres, roles y especialidades)",
          loadingProfessionals: "Cargando equipo…",
          tableProfessional: "Profesional",
          tableRole: "Rol / especialidad",
          tableLinkUser: "Vincular con usuario",
          noneUser: "— Ninguno —",
          noProfessionals:
            "No hay miembros en el equipo. Usa el botón de arriba para agregar desde la configuración inicial.",
          secuenciasIntro:
            "Elige qué Agente IA (Prompt) se usará para capturar solicitudes de cita por chat. El tono y la personalidad se configuran en ese Agente.",
          loading: "Cargando…",
          kanbanHint:
            "Si cambiaste el tipo de negocio, recrea las columnas Kanban según el perfil actual.",
          kanbanRecreate: "Recrear Kanban",
          kanbanProcessing: "Procesando…",
          edit: "Editar",
          editSectionAria: "Editar {{section}}",
          businessDialogTitle: "Datos del negocio",
          businessDialogDesc:
            "Edita el nombre, el perfil, la zona horaria y la moneda. Tus servicios, equipo, horarios y citas no se modifican.",
          businessDialogName: "Nombre del negocio",
          businessDialogProfile: "Perfil de negocio",
          businessDialogProfileHelper:
            "Si cambias el perfil, usa «Recrear Kanban» para actualizar las columnas del tablero.",
          businessDialogTimezone: "Zona horaria",
          businessDialogCurrency: "Moneda",
          businessDialogCancel: "Cancelar",
          businessDialogSave: "Guardar cambios",
          businessDialogSaving: "Guardando…",
          businessDialogSaved: "Datos del negocio actualizados.",
          toastLinkOk:
            "Vinculación actualizada. El instructor puede acceder a Agenda con su usuario.",
          toastKanbanOk: "Columnas Kanban recreadas según perfil.",
          errorProfileFirst:
            "Primero configura el perfil en la configuración inicial.",
          cardMensajeriaTitle: "Mensajería Masiva",
          cardMensajeriaDesc:
            "Campañas y recordatorios automáticos para los contactos de tu agenda.",
          mensajeriaIntro:
            "Gestiona los envíos masivos y recordatorios automáticos vinculados a tus citas.",
          mensajeriaCampaigns: "Campañas",
          mensajeriaCampaignsDesc: "Envíos masivos a listas de contactos",
          mensajeriaCampaignsLink: "Ir a Campañas",
          mensajeriaScheduled: "Mensajes Programados",
          mensajeriaScheduledDesc:
            "Recordatorios individuales y mensajes automáticos",
          mensajeriaScheduledLink: "Ir a Mensajes",
          servicesLoading: "Cargando servicios…",
          noServices:
            "No hay servicios configurados. Usa el botón de arriba para agregar.",
          addService: "Agregar servicio",
          activeProfile: "Perfil activo",
          svcRequiresPro: "Requiere profesional",
          svcProfessionals: "Profesionales",
        },
        appointmentModal: {
          titleNew: "Nueva cita",
          notifyContact: "Avisar al paciente ahora",
          notifyContactOn: "Se enviará la plantilla de confirmación por WhatsApp al guardar.",
          notifyContactOff: "La cita se creará confirmada, pero sin aviso inmediato.",
          titleEdit: "Cita {{code}}",
          contactFallback: "Contacto #{{id}}",
          client: "Cliente:",
          service: "Servicio:",
          professional: "Profesional:",
          date: "Fecha:",
          statusLabel: "Estado",
          viewProfile360: "Ver Perfil 360",
          rescheduleHint:
            "Indica la nueva fecha, servicio y profesional para reprogramar. Se enviará notificación al contacto.",
          newDateTime: "Nueva fecha y hora *",
          duration: "Duración (minutos)",
          notes: "Notas",
          introNew:
            "Registra una nueva cita manualmente. Escribe para buscar y selecciona de la lista filtrada.",
          contactLabel: "Contacto *",
          contactPlaceholder: "Escribe nombre o número para buscar...",
          contactHelper: "Obligatorio. Busca por nombre o teléfono.",
          noOptionsShort: "Escribe al menos 2 caracteres para buscar",
          noOptionsEmpty: "Sin resultados",
          connectionLabel: "Conexión *",
          connectionPlaceholder:
            "Selecciona la línea WhatsApp (conexión) de esta cita",
          connectionHelper:
            "Obligatorio. Indica desde qué conexión queda registrada la cita (misma lógica que el recordatorio programado).",
          connectionNamed: "Conexión {{id}}",
          dash: "—",
          serviceField: "Servicio",
          serviceSearchPh: "Buscar servicio...",
          serviceHelper: "Opcional. Catálogo de servicios.",
          noServices: "Sin servicios configurados",
          professionalField: "Profesional",
          professionalSearchPh: "Buscar profesional...",
          professionalHelper: "Opcional. Equipo de instructores.",
          noProfessionalsConfigured: "Sin profesionales configurados",
          datetimeLabel: "Fecha y hora *",
          datetimeHelper: "Obligatorio. Momento de la cita.",
          durationHelper: "Por defecto 60 minutos.",
          notesPlaceholder: "Observaciones adicionales...",
          cancel: "Cancelar",
          saveReschedule: "GUARDAR Y REAGENDAR",
          saveStatus: "Guardar estado",
          create: "Crear cita",
          toastContactDateRequired: "Contacto y fecha son obligatorios",
          toastWhatsappRequired:
            "Selecciona la conexión (WhatsApp) de la cita",
          toastStatusUpdated: "Estado actualizado",
          toastCreated: "Cita creada",
          toastRescheduleDateRequired:
            "La nueva fecha es obligatoria para reprogramar",
          toastRescheduled:
            "Cita reprogramada. Se envió notificación al contacto.",
        },
      },
      toDoList: {
        title: "Anotaciones del Operador",
        searchPlaceholder: "Buscar tareas...",
        stats: { total: "Total", pending: "Pendientes", completed: "Completadas", urgent: "Urgentes" },
        form: {
          newTask: "Nueva Tarea",
          editTask: "Editar Tarea",
          descriptionLabel: "Descripción de la tarea",
          descriptionPlaceholder: "Ej: Revisar configuración del servidor...",
          priority: "Prioridad",
          category: "Categoría",
          add: "Agregar Tarea",
          save: "Guardar Cambios",
          cancel: "Cancelar",
        },
        priority: { low: "Baja", medium: "Media", high: "Alta" },
        categories: {
          general: "General",
          urgent: "Urgente",
          followup: "Seguimiento",
          meeting: "Reunión",
          system: "Sistema",
          customer: "Cliente",
        },
        filters: { title: "Filtros", all: "Todas", allStatus: "Todos", status: "Estado" },
        statusLabel: { pending: "Pendiente", completed: "Completada" },
        empty: {
          none: "No hay tareas creadas",
          noneHint: "Crea tu primera tarea usando el formulario de arriba",
          filtered: "No se encontraron tareas con los filtros aplicados",
          filteredHint: "Ajusta los filtros para ver más tareas",
        },
        tooltips: {
          markPending: "Marcar como pendiente",
          markDone: "Marcar como completada",
          edit: "Editar tarea",
          delete: "Eliminar tarea",
        },
      },
      chat: {
        noTicketMessage: "Seleccione un ticket para comenzar a conversar.",
        buttons: {
          new: "Nuevo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO ABAJO",
          titleFileList: "Lista de archivo(s)"
        },
      },

      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
          closeallTicket: "Cerrar",
          closedAllTickets: "¿Estás seguro de cerrar por completo todos los tickets?" // ✅ MEJORADO: Mensaje más claro y específico
        },
        confirmation: {
          title: "⚠️ Confirmación de cierre de tickets", // ✅ MEJORADO: Título con icono de alerta y más específico
          subtitle: "Esta acción cerrará TODOS los tickets abiertos de forma permanente", // ✅ AGREGADO: Subtítulo explicativo
          warning: "Esta acción no se puede deshacer", // ✅ AGREGADO: Advertencia adicional
          whichTicketsQuestion: "¿Qué tickets deseas cerrar?",
          noTicketsForOption:
            "No hay tickets para cerrar según la opción seleccionada",
          warningEmojiAria: "Advertencia",
          optionAttendingOpen: "ATENDIENDO (Abiertos)",
          optionPending: "PENDIENTE",
          optionBoth: "AMBOS (ATENDIENDO + PENDIENTE)",
        }
      },
      tickets: {
        accessDenied: "No tienes acceso a este ticket",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolved: "Resueltos",
        },
        toasts: {
          deleted: "La atención en la que estaba ha sido eliminada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertas" },
          closed: { title: "Resueltos" },
          search: { title: "Búsqueda" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes",
          filterConnections: "Filtro por conexiones",
          filterContacts: "Filtro por contacto",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por Usuarios",
          ticketsPerPage: "Tickets por página",
          searchMessagesTooltip:
            "Buscar también en el contenido de los mensajes (más lento)",
        },
        buttons: {
          showAll: "Todos",
        },
        preview: {
          image: "🖼️ Imagen",
          video: "🎥 Video",
          audio: "🎵 Audio",
          document: "📄 Documento",
          sticker: "🔖 Sticker",
          location: "📍 Ubicación",
          contact: "👤 Contacto",
          deleted: "🚫 Mensaje eliminado",
          none: "Sin mensaje",
        },
        simple: {
          title: "Chats",
          scopeMine: "Míos",
          scopeMineDesc: "Chats asignados a ti",
          scopeAll: "Todos",
          scopeAllDesc: "Toda la empresa",
          chipOpen: "En atención",
          chipPending: "En espera",
          chipGroups: "Grupos",
          chipAi: "Agentes IA",
          chipClosed: "Resueltos",
          searchPlaceholder: "Buscar nombre, número o mensaje",
          filters: "Filtros",
          clearFilters: "Limpiar",
          searchInMessages: "Buscar también en los mensajes",
          queues: "Departamentos",
          tags: "Etiquetas",
          moreOptions: "Más opciones",
          resolveBulk: "Resolver chats en bloque",
          newChat: "Nuevo chat",
          chatActions: "Acciones del chat",
          viewConversation: "Ver conversación",
          otherConversation: "Este contacto tiene otra conversación abierta en otro canal",
          yesterday: "Ayer",
          backToList: "Volver a la lista",
          more: "Más acciones",
          scheduleMessage: "Programar mensaje",
          moreMenu: "Más",
          you: "Tú",
          noQueue: "Sin departamento",
          unassigned: "Sin asignar",
          profile: "Perfil",
          language: "Idioma",
          volume: "Volumen de avisos",
          colorTheme: "Tema de color",
          darkMode: "Modo oscuro",
          online: "En línea",
          search: "Buscar",
          searchPage: "Buscar página",
          noResults: "Sin resultados",
          paletteHint: "↑ ↓ navegar · Enter abrir · Esc cerrar",
        },
        managerTabs: {
          tooltips: {
            newTicket: "Crear nuevo ticket",
            resolveTickets: "Resolver tickets",
            showOpen: "Mostrar tickets abiertos",
            showClosed: "Mostrar tickets cerrados",
            filterByQueues: "Filtrar por departamentos",
            filterByTags: "Filtrar por etiquetas",
            activeFilters: "Ver filtros activos",
          },
          emptyQueues: "No hay departamentos disponibles",
          emptyTags: "No hay etiquetas disponibles",
          tabs: {
            groups: "GRUPOS",
            aiAgents: "AGENTES IA",
          },
        },
        filterPanel: {
          title: "Filtros",
          show: "Mostrar",
          hide: "Ocultar",
          departments: "Departamentos",
          tags: "Etiquetas",
          departmentsWithCount: "Departamentos ({{count}})",
          tagsWithCount: "Etiquetas ({{count}})",
          clearFilters: "Limpiar Filtros",
          emptyState:
            "No hay filtros activos. Selecciona departamentos o etiquetas arriba.",
        },
        welcome: {
          title: "Bienvenido a tu módulo de chat",
          subtitle:
            "Puedes abrir un nuevo chat o esperar a que se te asigne uno",
        },
        aria: {
          resizeTicketsPanel: "Redimensionar panel de tickets",
        },
        mobile: {
          bottomNav: {
            chat: "Chat",
            tickets: "Atenciones",
          },
        },
        searchResults: {
          searchAria: "Búsqueda",
          searching: "Buscando...",
          resultsFor: 'Resultados para "{{term}}"',
          noResults: "No se encontraron resultados",
          emptySection: "No hay resultados en esta sección.",
          total: "{{count}} en total",
          sections: {
            open: "ATENDIENDO",
            pending: "PENDIENTE",
            closed: "CERRADOS",
          },
        },
        // ✅ NUEVAS TRADUCCIONES PARA MENSAJES AUTOMÁTICOS
        automaticMessages: {
          title: "Mensaje Automático",
          callsDisabled: "Las llamadas de voz y video están deshabilitadas para este WhatsApp, favor enviar un mensaje de texto. Gracias",
          transferToDepartment: "Has sido transferido al departamento *{department}*\nespera, ya vamos a atenderte!",
          transferToAgent: "Has sido transferido al atendente *{agent}*\nespera, ya vamos a atenderte!",
          transferToDepartmentAndAgent: "Has sido transferido al departamento *{department}* y contarás con la presencia de *{agent}*\nespera, ya vamos a atenderte!",
          // ✅ MENSAJES DE ERROR DEL BACKEND
          pdfSendError: "No se pudo enviar el PDF, inténtalo nuevamente!",
          messageNotProcessable: "Mensaje no procesable",
          unrecognizedMessage: "Mensaje no reconocido",
          temporaryMessage: "Mensaje temporal",
          // ✅ PROMPTS DEL SISTEMA IA
          aiSystemPrompt: "En las respuestas utiliza el nombre {name} para identificar al cliente.\nTu respuesta debe usar máximo {maxTokens} tokens y cuida de no truncar el final.\nSiempre que sea posible, menciona su nombre para que el atendimiento sea más personalizado y educado. Cuando la respuesta requiere una transferencia para el sector de atendimiento, comienza tu respuesta con 'Acción: Transferir para el sector de atendimiento'.\n{prompt}\n",
          aiTransferMessage: "Lo siento, este agente IA no está asociado a un departamento específico. Por favor, contacta directamente con un agente humano.",
        },
      },
      transferTicketModal: {
        sinDestino: "Elegí un departamento o una persona: el ticket no puede quedar sin destino.",
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a departamento",
        fieldQueuePlaceholder: "Seleccione un departamento",
        fieldConnectionLabel: "Seleccione una conexión",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      transferConfirmationModal: {
        title: "Confirmar Transferencia",
        aiWarning: "El departamento {queueName} tiene activado AGENTE IA",
        promptInfo: "Prompt: {promptName}",
        aiQuestion: "¿Estás seguro de transferir? El ticket será atendido automáticamente por el agente IA.",
        humanQuestion: "¿Estás seguro de transferir al departamento {queueName}?",
        confirm: "Sí, Transferir",
        cancel: "Cancelar",
        transferring: "Transfiriendo...",
        successMessage: "Transferencia exitosa al departamento {queueName}",
      },
      ticketsList: {
        noQueue: "Sin departamento",
        spyConversation: "Espiar conversación",
        pendingHeader: "Pendiente",
        assignedHeader: "Atendiendo",
        allHeader: "Todos", // ✅ AGREGADO: Para pestaña "TODOS"
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          transfer: "Transferir",
          reopen: "Reabrir",
          ticketClosed: "Ticket cerrado correctamente",
          confirmCloseWithTagsTitle: "Confirmar cierre de ticket",
          confirmCloseWithTagsMessage:
            "Al cerrar se quitarán todas las etiquetas de este ticket. ¿Deseas continuar?",
          confirmCloseWithSendMessage:
            "Al confirmar el cierre se enviará al cliente un mensaje de WhatsApp según «Mensaje al cerrar ticket» en Configuraciones de mensajería (no aplica a grupos). ¿Deseas continuar?",
          confirmCloseBodyTagsAndMessage:
            "Al cerrar se quitarán todas las etiquetas de este ticket y se enviará al cliente el mensaje de cierre configurado en Mensajería. ¿Deseas continuar?"
        },
      },
      emailEditor: {
        bold: "Negrita",
        italic: "Cursiva",
        underline: "Subrayado",
        bullets: "Lista con viñetas",
        numbers: "Lista numerada",
        quote: "Cita",
        link: "Enlace",
        clear: "Quitar formato",
        linkPrompt: "Dirección del enlace (https://… o mailto:…)",
      },
      newTicketModal: {
        title: "Crear Ticket",
        email: {
          to: "Para",
          toPlaceholder: "correo@ejemplo.com",
          subject: "Asunto",
          body: "Mensaje",
          send: "Enviar correo",
          addCopies: "Añadir CC / CCO",
          cc: "CC (con copia)",
          bcc: "CCO (copia oculta)",
          copiesHint: "Varias direcciones separadas por comas.",
          attach: "Adjuntar archivos",
          sign: "Incluir mi firma",
          hint: "Se abre un hilo nuevo con este asunto. La respuesta del cliente llega a este mismo ticket.",
        },
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        selectQueue: "Seleccione un departamento",
        selectConnection: "Seleccione una conexión",
        departmentAttention: "Departamento de atención",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
        errors: {
          contactRequired: "Debe seleccionar un contacto para crear el ticket",
          connectionRequired: "Debe seleccionar una conexión",
          queueRequired: "Debe seleccionar un departamento",
        },
      },
      myTeam: {
        title: "Mi equipo",
        activity: "Actividad del equipo",
        online: "En línea",
        offline: "Desconectado",
        subtitle: "Tu empresa, los equipos a los que perteneces y quién los supervisa.",
        supervisor: "Supervisor",
        noSupervisor: "Este equipo aún no tiene supervisor asignado.",
        departments: "Departamentos que atiende",
        noDepartments: "Este equipo no tiene departamentos asignados.",
        members: "Miembros",
        youSupervise: "Supervisás este equipo",
        you: "vos",
        inheritsRole: "Hereda su rol",
        noTeams: "No pertenecés a ningún equipo. Trabajás con el alcance de tu rol.",
        table: {
          name: "Nombre",
          role: "Rol en este equipo",
          state: "Estado",
          handling: "Atendiendo",
          closedToday: "Cerrados hoy"
        }
      },
      userTeams: {
        label: "Equipo al que pertenece",
        labelOne: "Equipo que supervisa",
isSupervisor: "Ya es supervisor de este equipo.",
                willSupervise: "Será supervisor de {{team}}.",
supervisedByLabel: "supervisa",
        noSupervisor: "sin supervisor",
        required: "Debe pertenecer a un equipo.",
        noneFree: "No hay equipos libres: todos tienen supervisor",
        empty: "Todavía no hay equipos creados"
      },
      roleMatrix: {
        modules: {
          agenda: "Agenda",
          announcements: "Anuncios",
          api: "API",
          campaigns: "Campañas",
          chats: "Chat interno",
          connections: "Conexiones",
          contacts: "Contactos",
          files: "Lista de archivos",
          financial: "Facturación",
          flowbuilder: "FlowBuilder",
          groups: "Grupos de WhatsApp",
          kanban: "Kanban",
          prompts: "Agentes IA",
          queues: "Departamentos",
          quickmessages: "Respuestas rápidas",
          reports: "Informes",
          roles: "Roles y permisos",
          schedules: "Mensajes programados",
          settings: "Configuración",
          tags: "Etiquetas",
          tickets: "Tickets",
          "user-groups": "Subagrupaciones",
          users: "Usuarios"
        },
        page: {
          title: "Roles y permisos",
          subtitle: "Definí qué puede hacer cada rol en cada módulo (ver / crear / editar / eliminar…).",
          newRole: "Nuevo rol",
          colCode: "Código",
          colName: "Nombre",
          colScope: "Ámbito",
          colPerms: "Permisos",
          colUsers: "Usuarios",
          colActions: "Acciones",
          systemTooltip: "Rol del sistema: al editarlo se creará una copia de tu empresa",
          duplicate: "Duplicar",
          duplicated: "Rol duplicado",
          deleted: "Rol eliminado",
          confirmDeleteTitle: "¿Eliminar el rol {{name}}?",
          confirmDeleteBody: "Los usuarios que tengan este rol deberán reasignarse antes de eliminarlo.",
          duplicateTitle: "Duplicar rol: {{name}}",
          duplicateHint: "Se creará un rol nuevo y editable con los {{total}} permisos del original. El rol de origen no se modifica.",
          copyCodeSuffix: "_COPIA",
          copyNameSuffix: " (copia)"
        },
        scopes: {
          empresa: "Empresa",
          equipo: "Equipo",
          personal: "Personal",
          plataforma: "Plataforma"
        },
        modal: {
          new: "Nuevo rol",
          edit: "Editar rol: {{name}}",
          subtitle: "Marcá lo que este rol puede hacer en cada módulo.",
          superadminNotice: "El rol SUPERADMIN no se puede modificar: es el único que podría dejar al sistema sin nadie capaz de restaurar permisos.",
          copyNotice: "Este rol lo comparten todas las empresas. Al guardar se creará una versión propia de tu empresa con tus cambios; las demás no se verán afectadas.",
code: "Código",
          name: "Nombre",
                    frozenTooltip: "No puede modificar un permiso que usted no tiene",
          saved: "Matriz actualizada",
          sessionsNotice: "Afecta a {{total}} usuario(s); lo verán en cuanto recarguen",
          selectedCount: "{{total}} permiso(s) seleccionado(s)",
          save: "Guardar",
          cancel: "Cancelar"
        },
        bulk: {
          all: "Marcar todo",
          allClear: "Desmarcar todo",
          column: "Marcar toda la columna",
          columnClear: "Desmarcar toda la columna",
          row: "Marcar toda la fila",
          rowClear: "Desmarcar toda la fila"
        },
        columns: {
          module: "Módulo"
        },
        actions: {
          ver: "Ver",
          crear: "Crear",
          editar: "Editar",
          eliminar: "Eliminar",
          aprobar: "Aprobar",
          procesar: "Procesar",
          administrar: "Administrar"
        }
      },
      mainDrawer: {
        groups: {
          whatsapp: "Chats",
          dashboard: "Informes",
          gruposWA: "Grupos de WA",
          mensajes: "Mensajería",
          configuracion: "Configuración",
          administracion: "Administración",
          flowbuilder: "FlowBuilder",
          utilidades: "Utilitarios",
        },
        listItems: {
          dashboard: "Tablero",
          connections: "Conexiones",
          wabaTemplates: "Plantillas Meta",
          metrics: "Informes",
          platform: "Estado de la plataforma",
          tickets: "Tickets",
          quickMessages: "Respuestas Rápidas",
          kanban: "Kanban",
          todolist: "Apuntes",
          contacts: "Contactos",
          groupsWA: "Lista de Grupos WA",
          queues: "Departamentos",
          tags: "Etiquetas",
          administration: "Administración",
          users: "Usuarios",
          userRoles: "Rol de usuario",
          rolesPermissions: "Roles y permisos",
          securityAudit: "Seguridad",
          userGroups: "Subagrupaciones",
          myTeam: "Mi equipo",
          settings: "Configuraciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Agenda",
          campaigns: "Campañas",
          campaignsDispatch: "Envío de mensajes",
          metaCampaigns: "Campañas Meta",
          scheduledMessages: "Individual",
          contactLists: "Lista de contactos",
          campaignShippingReports: "Informe de Envío",
          broadcastTemplates: "Plantillas de Difusión",
          annoucements: "Anuncios",
          chats: "Chat Interno",
          localChat: "Chat local",
          financeiro: "Suscripciones",
          subscription: "Subscripción",
          files: "Lista de archivos",
          prompts: "Agentes IA",
          queueIntegration: "Integraciones",
          flowbuilders: "Lista de Flujos",
          flowcampaigns: "Campañas de Flujo",
          dashboardWhatsApp: "WhatsApp",
          vpsPerformance: "Rendimiento VPS",
          groupCampaigns: "Campañas de Grupos",
        },
        appBar: {
          notRegister: "Sin notificaciones",
          user: {
            profile: "Perfil de usuario",
            logout: "Cerrar sesión",
            label: "Usuario:",
          },
          tooltips: {
            openDrawer: "Abrir menú",
            closeDrawer: "Cerrar menú",
            navigationMenu: "Menú de navegación",
            openNavigationMenu: "Abrir menú de navegación",
            internalChat: "Chat interno",
            help: "Ayuda",
            announcements: "Anuncios",
            whatsappNotifications: "Mensajes de tus canales",
            settings: "Configuración",
            updateVersion: "Actualizar versión",
            logout: "Salir",
          },
          settingsMenu: {
            lightMode: "Modo claro",
            darkMode: "Modo oscuro",
            logs: "Registros (logs)",
          },
          versionLong: "VERSIÓN {{version}}",
          versionShort: "V{{version}}",
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! y se eliminará de los departamentos y conexiones vinculadas",
        },
      },
      files: {
        title: "Lista de archivos",
        adminTitle: "Administrador de archivos",
        searchPlaceholder: "Buscar listas de archivos...",
        newList: "Nueva lista de archivos",
        listCount: "{{count}} listas",
        table: {
          name: "Nombre de la lista",
          description: "Descripción",
          fileCount: "Cantidad de archivos",
          createdAt: "Fecha de creación",
          actions: "Acciones",
        },
        noDescription: "Sin descripción",
        filesInList: "{{count}} archivos",
        tooltips: { editList: "Editar lista de archivos", deleteList: "Eliminar lista de archivos" },
        contacts: "Contactos",
        actions: "Acción",
        toasts: {
          deleted: "¡Lista eliminada correctamente!",
          deletedAll: "¡Todas las listas se han eliminado correctamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?",
        },
      },
      messagesAPI: {
        reference: {
          copy: "Copiar",
          copied: "Copiado al portapapeles",
          request: "Ejemplo de solicitud",
          response: "Ejemplo de respuesta",
          curl: "Ejemplo cURL",
          paramName: "Parámetro",
          paramValue: "Valor / descripción",
          textBody: "Texto del mensaje",
          mediaFile: "Archivo (imagen, video, documento o audio)",
          optionalText: "Texto acompañante (opcional)",
          groupId: "ID del grupo (el sistema agrega @g.us)",
        },
        auth: {
          title: "Autenticación",
        },
        instance: {
          comingSoon: "Próximamente",
          body: "Gestión de la conexión por API (solo Baileys): consulta el estado, obtén el código QR y fuerza la reconexión. El token Bearer identifica la conexión.",
          statusTitle: "Estado de la conexión",
          statusDesc: "Devuelve el estado actual: conectado/desconectado, número vinculado, batería y proveedor.",
          qrTitle: "Código QR",
          qrDesc: "Devuelve la cadena QR (qrcode) y también la imagen lista qrImage (data:image/png;base64) para mostrar con <img> directo. Si viene vacía, fuerza la generación con POST /reconnect y consulta de nuevo hasta que aparezca.",
          qrNote: "Flujo típico: POST /reconnect para generar un QR fresco → consulta GET /qr cada pocos segundos hasta escanear → GET /status confirma CONNECTED.",
          qrViewTitle: "Página QR alojada",
          qrViewDesc: "Página HTML lista para usar que muestra el QR en vivo, lo renueva automáticamente y detecta la conexión. Ábrela en el navegador o incrústala en un iframe — ideal para clientes sin frontend (Excel, scripts). El token va en la URL.",
          qrViewNote: "Onboarding sin código: el usuario final escanea y la página detecta CONNECTED sola. El token viaja en la URL (usar en enlaces de corta vida).",
          reconnectTitle: "Reconectar",
          reconnectDesc: "Re-inicia la sesión y genera un QR fresco si hace falta (no borra credenciales). Útil cuando la conexión se cae.",
          rebootTitle: "Reiniciar (reboot)",
          rebootDesc: "Cierra la sesión de WhatsApp Web (logout) y fuerza un nuevo escaneo. Limpia el estado pero conserva la configuración de la conexión.",
          rebootNote: "Acción destructiva: desconecta el número actual. Tendrás que escanear un QR nuevo para volver a conectar.",
          resetTitle: "Reset total",
          resetDesc: "Borrón y cuenta nueva: cierra la sesión, elimina las credenciales guardadas y genera un QR nuevo desde cero.",
          resetNote: "Acción destructiva e irreversible: elimina las credenciales de la conexión. Úsalo solo si necesitas vincular otro número o resolver un estado corrupto.",
          webhookTitle: "Registrar webhook",
          webhookDesc: "Registra una URL que recibirá eventos de la conexión (por ahora: cambios de estado de conexión). Los eventos se envían por POST con { event, instanceId, timestamp, data }.",
          webhookUrlParam: "URL https que recibirá los eventos (POST)",
          webhookEnableParam: "true/false para activar o desactivar (opcional; por defecto true si hay url)",
          webhookNote: "Se envían eventos de estado de conexión (event: connection.update); cuando el estado es qrcode, el payload incluye qrcode + qrImage (recibes el QR por push, sin poll). Los eventos de mensajes entrantes/salientes llegarán en una versión posterior.",
        },
        nav: {
          auth: "Autenticación",
          instance: "Instancia / Conexión",
          messages: "Mensajería",
          groups: "Grupos",
          external: "CRM / External",
          account: "Cuenta / Provisión",
        },
        account: {
          body: "Endpoints de nivel CUENTA para provisionar conexiones. Usan la API Key de cuenta (no el token per-conexión). La creación respeta el límite de conexiones de tu plan.",
          keyTitle: "API Key de cuenta",
          keyLoading: "Cargando…",
          keyWarning: "Trátala como una contraseña. Al regenerarla, la anterior deja de funcionar.",
          regenerate: "Regenerar API Key",
          regenerated: "API Key regenerada",
          keyHidden: "Guardada (termina en {{preview}}). Por seguridad no se vuelve a mostrar: regénérala si la necesitas.",
          copyNow: "Copia la clave ahora: por seguridad no se volverá a mostrar.",
          regenerateError: "No se pudo regenerar la API Key",
          createTitle: "Crear conexión",
          createDesc: "Crea una nueva conexión (instancia) en la cuenta y devuelve su token per-conexión para operarla después. Respeta la cuota de conexiones del plan.",
          createNameParam: "Nombre de la conexión (requerido)",
          createProviderParam: "baileys (por defecto y único admitido)",
          createNote: "El token devuelto es el token per-conexión: úsalo en /api/v1/instance/* y /api/messages/*. Si superas el límite del plan, responde error de cuota.",
          listTitle: "Listar conexiones",
          listDesc: "Lista todas las conexiones de la cuenta con su estado y token per-conexión.",
        },
        title: "API Pública",
        subtitle: "Motor: Baileys · No es API oficial de WhatsApp (WABA)",
        subtitleBody: "Estos endpoints funcionan exclusivamente con conexiones Baileys. No son compatibles con la API oficial de WhatsApp Business (WABA/Cloud API). Pueden ser consumidos por sistemas externos, integraciones N8N/TypeBot o cualquier cliente HTTP que disponga del token de conexión registrado en el panel.",
        documentation: {
          title: "Documentación para envío de mensajes",
          methods: "Métodos de Envío",
          instructions: "Instrucciones",
          importantNotes: "Observaciones importantes",
          textMessages: "Mensajes de Texto",
          mediaMessages: "Mensajes Multimedia",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Headers",
          body: "Body",
          formData: "FormData",
          testSend: "Prueba de Envío",
          send: "Enviar",
        },
        instructions: {
          tokenRequired:
            "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el campo correspondiente.",
          numberFormat:
            "El número para envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
          countryCode: "Código del país",
          areaCode: "DDD",
          number: "Número",
        },
        importantInfo: {
          title: "Información Importante",
          tokenLabel: "Token requerido",
          tokenBody:
            "Debes registrar un token vinculado a la conexión que enviará los mensajes",
          formatLabel: "Formato del número",
          formatBody:
            "Código de país + DDD + número (sin caracteres especiales)",
          exampleLabel: "Ejemplo",
          exampleBody:
            "51999888777 (Perú: 51, DDD: 999, Número: 888777)",
        },
        chips: {
          endpoint: "ENDPOINT",
          method: "MÉTODO",
          headers: "HEADERS",
          upTo100mb: "HASTA 100MB",
        },
        common: {
          apiInfoTitle: "Información de la API",
          testSendTitle: "Prueba de Envío",
          bodyJson: "Body (JSON):",
          formData: "FormData:",
        },
        section1: {
          title: "1. Mensajes de Texto",
          intro:
            "Envía mensajes de texto simples a través de la API pública de mensajería.",
          bodySnippet: `{ "number": "51999888777", "body": "Su mensaje" }`,
        },
        section2: {
          title: "2. Mensajes Multimedia",
          intro:
            "Envía archivos multimedia (imágenes, videos, documentos, audio) a través de la API pública de mensajería.",
          maxCapacity: "Capacidad máxima:",
          maxCapacityBody: "Archivos de hasta 100 MB",
          formDataNumber: "number:",
          formDataNumberEx: "51999888777",
          formDataMedias: "medias:",
          formDataMediasEx: "archivo",
          formDataBody: "body:",
          formDataBodyEx: "mensaje opcional (texto acompañante)",
          fileTypesTitle: "Tipos de archivo soportados:",
          images: "Imágenes:",
          imagesEx: "JPG, PNG, GIF (hasta 5MB)",
          videos: "Videos:",
          videosEx: "MP4, AVI, MOV (hasta 16MB)",
          documents: "Documentos:",
          documentsEx: "PDF, DOC, XLS, PPT (hasta 100MB)",
          audio: "Audio:",
          audioEx: "MP3, WAV, OGG (hasta 16MB)",
        },
        section3: {
          title: "3. Mensajes a Grupos de WhatsApp",
          intro:
            "Envía mensajes de texto a grupos de WhatsApp a través de la API.",
          bodySnippet: `{ "number": "12036312345678901234", "body": "Su mensaje" }`,
          groupNote: "Nota:",
          groupNoteBody:
            "El sistema automáticamente agregará el sufijo @g.us al ID del grupo",
        },
        section4: {
          title: "4. Mensajes Multimedia a Grupos",
          intro:
            "Envía archivos multimedia (imágenes, videos, documentos, audio) a grupos de WhatsApp a través de la API pública de mensajería.",
          formDataNumberLi: "ID del grupo (ej: 12036312345678901234)",
          formDataMediasLi: "archivo multimedia",
        },
        forms: {
          tokenRegistered: "Token registrado",
          tokenRegisteredReq: "Token registrado *",
          tokenPlaceholder: "Ingresa tu token aquí",
          number: "Número",
          numberReq: "Número *",
          message: "Mensaje",
          messageReq: "Mensaje *",
          messageOptional: "Mensaje (Opcional)",
          messageOptionalPlaceholder:
            "Escribe un mensaje opcional para acompañar el archivo...",
          messagePlaceholder: "Escribe tu mensaje aquí",
          numberPlaceholder: "51999888777",
          fileName: "Nombre del archivo",
          sendMessage: "ENVIAR MENSAJE",
          sendMedia: "Enviar Multimedia",
          selectFile: "Seleccionar Archivo",
          clickUploadHint:
            "Haz clic para seleccionar un archivo multimedia",
          fileSize: "Tamaño:",
          groupId: "ID del Grupo *",
          groupIdHelper:
            "ID del grupo sin @g.us (ej: 12036312345678901234)",
          groupIdHelperShort: "ID del grupo sin @g.us",
          sendToGroup: "Enviar a Grupo",
          sendMediaToGroup: "Enviar Multimedia a Grupo",
        },
        fileSize: {
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
        apiInfo: {
          textMessageInfo:
            "A continuación se muestra la lista de información necesaria para el envío de mensajes de texto:",
          mediaMessageInfo:
            "A continuación se muestra la lista de información necesaria para el envío de mensajes multimedia:",
          authorization:
            "Authorization (Bearer token) y Content-Type (application/json)",
          multipartForm:
            "Authorization (Bearer token) y Content-Type (multipart/form-data)",
          exampleBody: '{ "number": "51999888777", "body": "Su mensaje" }',
          exampleNumber: "51999888777",
          exampleFile: "archivo",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        section5: {
          d: {
            byNumber: "Consulta el estado y los datos de un ticket a partir del número del contacto (país + DDD + número). Devuelve el objeto variables con la información del ticket.",
            byId: "Igual que la consulta por número, pero usando el ID interno del ticket.",
            users: "Lista los usuarios/agentes de la empresa (id, nombre, email). Útil para asignar tickets a un agente.",
            tags: "Lista las etiquetas disponibles (id, nombre). Útil para saber qué tagId asignar.",
            assignTag: "Asigna una etiqueta a un ticket existente.",
            updateTicket: "Actualiza un ticket: cambia su estado, el agente asignado y/o la cola.",
            tagIdValue: "ID de la etiqueta a asignar (ver GET /tags)",
            statusValue: "Estado del ticket: open, pending o closed",
            userIdValue: "ID del agente a asignar (ver GET /users)",
            queueIdValue: "ID de la cola/departamento",
            typebotTitle: "Compatibilidad Typebot / N8N (alternativa POST)",
            typebotDesc: "Plataformas que solo permiten POST (como Typebot) pueden consultar/crear el ticket enviando los datos por body o por query params. La respuesta incluye el objeto variables listo para mapear en tus variables de flujo.",
            typebotNumber: "Número del contacto (o usa ?number={{telefono}} en la URL)",
            typebotAtendimento: "Alternativamente, el ID del ticket (atendimento)",
            typebotNote: "En Typebot: en el bloque HTTP Request usa POST con la URL /ticket?number={{telefono}}, cabecera Authorization: Bearer <TOKEN>, y guarda la respuesta en variables (data.variables.numero, nome, atendimento).",
            variablesDesc: "Todas las respuestas de ticket incluyen este objeto variables, listo para mapear en tu flujo:",
          },
          title: "5. API Externa - N8N / TypeBot",
          intro:
            "Endpoints para integraciones externas (N8N, TypeBot, etc.). Usa el mismo token de WhatsApp que la API de mensajería. Las respuestas incluyen el objeto variables compatible con TypeBot/N8N.",
          baseUrl: "Base URL:",
          headersLine: "Headers:",
          getTicketByNumber: "GET - Ticket por número",
          getTicketById: "GET - Ticket por ID",
          getUsers: "GET - Usuarios/Agentes",
          getTags: "GET - Etiquetas",
          putAssignTag: "PUT - Asignar etiqueta",
          putUpdateTicket: "PUT - Actualizar ticket",
          bodyLabel: "Body:",
          altPostTitle:
            "Alternativa POST (body o query params para Typebot):",
          postTicketBody1: 'POST {{base}}/ticket - Body: { "atendimento": 1223 } o { "number": "51980795334" }',
          postTicketBody2:
            "POST {{base}}/ticket?number={{telefono}} - Variables en URL (Typebot)",
          postTicketBody3:
            "POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 - Query params",
          postTicketBody4:
            'POST {{base}}/ticket - Body: { "atendimento": 1223, "status": "open", "userId": 1 } (actualizar)',
          postUsersTags: "POST {{base}}/users - POST {{base}}/tags",
          variablesObjectTitle: "Objeto variables (en respuestas ticket):",
          variablesList:
            "atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
          typebotGuideTitle: "Guia Typebot (flujo validado):",
          typebotStep1:
            "Input: preguntar numero, guardar en variable telefono",
          typebotStep2:
            "HTTP Request: POST /ticket?number={{telefono}} (usar icono de llaves para insertar variable)",
          typebotStep3: "Headers: Authorization = Bearer token",
          typebotStep4:
            "Save in variables: data.variables.numero, nome, atendimento",
          typebotStep5: "Text: mostrar numero, nome, atendimento",
          seeGuide: "Ver guia 0275 para detalle completo.",
        },
        messages: {
          success: "Mensaje enviado exitosamente",
          successMedia: "Mensaje multimedia enviado exitosamente",
          successGroup: "Mensaje enviado al grupo exitosamente",
          successGroupMedia:
            "Mensaje multimedia enviado al grupo exitosamente",
          groupSendError: "Error al enviar mensaje al grupo",
          groupMediaError: "Error al enviar multimedia al grupo",
          noPermission:
            "Esta empresa no tiene permiso para acceder a esta página. Estamos redirigiéndolo.",
        },
        errors: {
          backendUrlNotConfigured: "REACT_APP_BACKEND_URL no está configurado",
        },
      },
      notifications: {
        noTickets: "No hay notificaciones.",
        noRecords: "Sin registros",
        whatsappDisconnected: {
          title: "Sin conexiones WhatsApp",
          body:
            "No hay conexiones activas. Configura o reconecta tus conexiones WhatsApp para continuar.",
          reconnect: "RECONECTAR AHORA",
          close: "Cerrar",
        },
      },
      whatsappConnectionsMenu: {
        loadingConnections: "Cargando conexiones…",
        tooltipNoConnections:
          "Sin conexiones WhatsApp — pulse para ver detalles",
        tooltipSomeConnected:
          "Hay al menos una conexión activa — pulse para ver el listado",
        tooltipNoneActive:
          "Ninguna conexión activa — pulse para ver el listado",
        ariaLabel: "Estado de conexiones WhatsApp",
        menuTitle: "Conexiones WhatsApp",
        loading: "Cargando…",
        noneConfigured: "No hay conexiones configuradas",
        connectionFallback: "Conexión #{{id}}",
        manage: "Gestionar conexiones…",
        status: {
          connected: "Conectado",
          opening: "Conectando…",
          disconnected: "Desconectado",
        },
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        searchFieldPlaceholder: "Buscar respuestas rápidas...",
        noAttachment: "Sin adjunto",
        noFile: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Quieres continuar?",
        },
        buttons: {
          add: "Agregar",
          addReply: "Agregar Respuesta",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado correctamente!",
          deleted: "¡Atajo eliminado correctamente!",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir vista",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
          shortcodeHeader: "ATAJO",
          mediaNameHeader: "NOMBRE DEL ARCHIVO",
          statusHeader: "ESTADO",
          actionsHeader: "ACCIONES",
        },
        tooltips: {
          openAttachment: "Clic para abrir archivo",
          edit: "Editar respuesta rápida",
          delete: "Eliminar respuesta rápida",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        tooltipContactVars: "Variables de contacto",
        tooltipSystemVars: "Variables del sistema",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
          importMessage: "¿Desea importar los contactos de esta hoja de cálculo?",
          importTitle: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      flowbuilders: {
        title: "Flujos Automatizados",
        searchPlaceholder: "Buscar flujos...",
        noFlows: "No hay flujos creados",
        rowsPerPage: "Filas por página",
        buttons: {
          add: "Nuevo Flujo",
        },
        table: {
          name: "Nombre",
          status: "Estado",
          createdAt: "Creado",
          actions: "Acciones",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        actions: {
          edit: "Editar",
          delete: "Eliminar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Flujo",
          deleteMessage: "¿Está seguro de que desea eliminar este flujo? Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Flujo eliminado exitosamente",
          created: "Flujo creado exitosamente",
          updated: "Flujo actualizado exitosamente",
          saved: "Flujo guardado exitosamente",
          saveSuccess: "Flujo guardado exitosamente",
          saveError: "Error al guardar el flujo",
        },
        loading: "Cargando flujo...",
        editor: {
          nodesPanel: "Nodos Disponibles",
          newFlow: "Nuevo Flujo",
          saving: "Guardando",
          save: "Guardar",
          cancel: "Cancelar",
          canvas: "Canvas del Flujo",
          noNodes: "No hay nodos en el flujo. Haz clic en un nodo del panel lateral para agregarlo.",
          connecting: "Conectando... (Haz clic en otro nodo)",
          connectionHint: "Shift + Click en un nodo para iniciar conexión, luego haz clic en otro nodo para conectar",
          nodesHint: "Haz clic en un nodo para agregarlo al canvas",
          shortcuts: "Atajos de teclado",
          shortcutDrag: "Arrastra: Click y arrastra para mover",
          shortcutConnect: "Conectar: Shift + Click en nodo origen, luego Click en nodo destino",
          shortcutConfig: "Configurar: Click en el nodo o doble click",
        },
        modals: {
          title: "Configurar {nodeType}",
          cancel: "Cancelar",
          save: "Guardar",
          noConfig: "Este nodo no requiere configuración",
          message: {
            text: "Texto del mensaje",
          },
          condition: {
            variable: "Variable",
            operator: "Operador",
            value: "Valor",
          },
          start: {
            description: "El nodo de inicio es el punto de entrada del flujo. No requiere configuración adicional.",
          },
        },
        simulator: {
          title: "Previsualizar bot",
          restart: "Reiniciar",
          banner:
            "Simulación: no se envía ningún mensaje real ni se modifica ningún ticket.",
          canvasLocked: "El área de trabajo está bloqueada durante la vista previa",
          empty: "Pulsa Previsualizar para recorrer el flujo paso a paso.",
          running: "Recorriendo el flujo…",
          hsmBadge: "Plantilla WABA",
          chooseOption:
            "Selecciona una opción para continuar. En conversaciones reales la elección la hace el cliente.",
          typeReply: "Escribe la respuesta del cliente para continuar.",
          replyPlaceholder: "Respuesta del cliente…",
          freeTextPlaceholder: "…o escribe cualquier respuesta (p. ej. 9)",
          noOptions:
            "Este nodo no tiene opciones configuradas: el flujo quedaría bloqueado aquí.",
          connectionTitle: "Conexión",
          connectionHint:
            "De la conexión dependen los avisos por canal: hay nodos que un proveedor no soporta.",
          connectionAuto: "Automática (primera compatible)",
          contactTitle: "Contacto simulado",
          // Sin llaves dobles a propósito: i18next las trataría como interpolación y las vaciaría.
          contactHint:
            "Alimenta las variables de nombre, primer nombre y número del contacto, y con ellas el resultado de los nodos de condición.",
          contactName: "Nombre",
          contactNumber: "Número",
          executeHttp: "Ejecutar de verdad las llamadas HTTP",
          executeAi: "Ejecutar de verdad los nodos de IA (consume tokens)",
          variablesTitle: "Variables del flujo",
          status: {
            waiting: "Esperando respuesta",
            completed: "Flujo completado",
            error: "Error",
            running: "En ejecución",
          },
          errors: {
            generic: "No se pudo ejecutar la previsualización",
          },
        },
        validation: {
          noStartNode: "El flujo debe tener al menos un nodo de inicio",
          nameRequired: "El nombre del flujo es requerido",
          panelTitle: "Validación del flujo",
          allGood: "El flujo no presenta problemas",
          errorsLabel: "{{count}} error(es)",
          warningsLabel: "{{count}} advertencia(s)",
          blockedPreview:
            "Corrige los errores antes de previsualizar el flujo",
          goToNode: "Ir al nodo",
          codes: {
            EMPTY_FLOW: "El flujo no tiene nodos",
            NO_START_NODE: "El flujo no tiene nodo de inicio: nunca se ejecutará",
            MULTIPLE_START_NODES:
              "Hay {{count}} nodos de inicio. El motor tomará solo uno y el resto se ignorará",
            START_NO_EXIT:
              "El nodo de inicio no tiene conexión de salida: el flujo termina sin hacer nada",
            PAUSE_NODE_NO_EXIT:
              "«{{nodeLabel}}» espera respuesta del usuario pero no tiene conexión de salida: el flujo quedará colgado",
            CONDITION_MISSING_BRANCH: "La condición «{{nodeLabel}}» no tiene a dónde ir en: {{missing}}. Si el cliente cae ahí, el bot se queda callado. Conecta esa salida o, si la rama sobra, bórrala en la condición",
            BRANCH_NO_EXIT:
              "«{{nodeLabel}}» tiene {{count}} salida(s) sin conectar ({{missing}}) y no hay conexión por defecto",
            BRANCH_USES_FALLBACK:
              "«{{nodeLabel}}» tiene {{count}} salida(s) sin conectar ({{missing}}): usarán la conexión por defecto",
            DEAD_END: "Aquí termina la conversación («{{nodeLabel}}»). Si es el final previsto, puedes ignorarlo; para dejarlo explícito, conéctalo a «Cerrar ticket» o «Transferir a departamento»",
            ORPHAN_NODE:
              "«{{nodeLabel}}» no es alcanzable desde el nodo de inicio: nunca se ejecutará",
            INFINITE_LOOP:
              "Bucle sin punto de espera ({{length}} nodos): el motor se detendrá al llegar a {{maxIterations}} iteraciones y el flujo quedará en error",
            EMPTY_TEXT: "«{{nodeLabel}}» no tiene texto configurado",
            MISSING_MEDIA: "«{{nodeLabel}}» no tiene archivo cargado",
            MENU_NO_OPTIONS: "El menú «{{nodeLabel}}» no tiene opciones",
            BUTTONS_NO_BUTTONS: "«{{nodeLabel}}» no tiene botones configurados",
            HSM_NO_TEMPLATE: "«{{nodeLabel}}» no tiene plantilla seleccionada",
            HSM_NO_CONNECTION:
              "«{{nodeLabel}}» no tiene conexión WABA seleccionada",
            TAG_NO_TAG: "«{{nodeLabel}}» no tiene etiqueta seleccionada",
            TRANSFER_NO_QUEUE:
              "«{{nodeLabel}}» no tiene departamento de destino",
            JUMP_NO_FLOW: "«{{nodeLabel}}» no tiene flujo destino seleccionado",
            FILEINPUT_NO_TEXT:
              "«{{nodeLabel}}» no tiene texto de petición: el cliente no sabría qué enviar",
            JUMP_HAS_EXIT:
              "«{{nodeLabel}}» tiene nodos conectados después: no se ejecutarán, el control pasa al flujo destino",
            INPUT_NO_EXHAUSTED_EXIT: "«{{nodeLabel}}» tiene tope de {{count}} intentos pero la salida «sin respuesta válida» no está conectada: seguirá preguntando",
            CLOSE_HAS_EXIT:
              "«{{nodeLabel}}» tiene nodos conectados después: no se ejecutarán, el ticket queda cerrado",
            SETVAR_NO_KEY:
              "«{{nodeLabel}}» no tiene nombre de variable configurado",
            HTTP_NO_URL: "«{{nodeLabel}}» no tiene URL configurada",
            CONDITION_NO_VARIABLE:
              "«{{nodeLabel}}» no tiene variable a evaluar",
            CONDITION_BRANCH_EMPTY:
              "«{{nodeLabel}}» tiene una rama sin comparaciones: nunca se cumplirá",
            CONTENT_NO_ITEMS:
              "«{{nodeLabel}}» no tiene elementos: no enviará nada",
            CONTENT_ITEMS_EMPTY:
              "«{{nodeLabel}}» tiene {{count}} de {{total}} elemento(s) sin contenido: se omitirán al enviar",
            OPENAI_NO_PROMPT:
              "«{{nodeLabel}}» no tiene Agente IA seleccionado: usará la configuración heredada",
            TIMING_ZERO: "«{{nodeLabel}}» tiene un tiempo de 0: no hará nada",
            NODE_REQUIRES_WABA:
              "«{{nodeLabel}}» solo funciona en flujos de WhatsApp Cloud API (WABA)",
            TELEGRAM_BUTTONS_AS_MENU:
              "«{{nodeLabel}}»: en Telegram los botones llegan como menú numerado (el cliente responde «1», «2»…)",
          },
        },
      },
      flowcampaigns: {
        title: "Campañas de Flujo",
        searchPlaceholder: "Buscar campañas...",
        noCampaigns: "No hay campañas creadas",
        rowsPerPage: "Filas por página",
        buttons: {
          add: "Nueva Campaña",
        },
        table: {
          name: "Nombre",
          flow: "Flujo",
          phrases: "Frases",
          whatsapps: "WhatsApp(s)",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          active: "Activa",
          inactive: "Inactiva",
        },
        actions: {
          edit: "Editar",
          delete: "Eliminar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Campaña",
          deleteMessage: "¿Está seguro de que desea eliminar esta campaña? Esta acción no se puede deshacer.",
        },
        toasts: {
          created: "Campaña creada exitosamente",
          updated: "Campaña actualizada exitosamente",
          deleted: "Campaña eliminada exitosamente",
        },
        form: {
          title: "Nueva Campaña",
          editTitle: "Editar Campaña",
          name: "Nombre de la Campaña",
          flow: "Flujo Asociado",
          phrases: "Frases de Activación",
          addPhrase: "Agregar Frase",
          phraseTypes: {
            exact: "Exacta",
            contains: "Contiene",
            startsWith: "Comienza con",
            endsWith: "Termina con",
          },
          whatsapps: "WhatsApp(s)",
          status: "Campaña Activa",
          save: "Crear",
          update: "Actualizar",
          cancel: "Cancelar",
        },
        validation: {
          nameRequired: "El nombre de la campaña es requerido",
          flowRequired: "Debe seleccionar un flujo",
          phraseRequired: "Debe proporcionar al menos una frase de activación",
          whatsappRequired: "Debe seleccionar al menos un WhatsApp",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          aiAgent: "Agente IA",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programada",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        placeholders: {
          notDefined: "No definido",
          notDefinedMale: "No definido",
          noScheduling: "Sin programación",
          notCompleted: "No completada",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            messageVariables: "Variables disponibles: {{firstName}}, {{name}}, {{ms}}, {{protocol}}, {{hora}}",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programada",
            confirmation: "Confirmación",
            contactList: "Lista de Contacto",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Archivos",
          },
          ai: {
            wizardQuestion: "¿Desea usar Inteligencia Artificial dinámica en sus mensajes de esta campaña?",
            wizardHelp:
              "Con IA, cada contacto puede recibir un mensaje personalizado según el agente que elija y el texto base (semilla) que escriba. Sin IA, el envío sigue igual que siempre. Con IA debe configurar etiquetado ante respuesta.",
            choiceNo: "No — modo clásico (Msg. 1–5 y adjuntos como hasta ahora)",
            choiceYes: "Sí — IA dinámica (semilla única + agente Prompt)",
            continue: "Continuar",
            modeLabel: "Modo mensaje masivo",
            modeClassic: "Clásico (sin IA en el texto enviado)",
            modeAi: "IA dinámica (mensaje único adaptado por contacto)",
            promptAgent: "Agente IA (lista / legado)",
            promptAgentSend: "Agente IA (personaliza cada envío)",
            replyPromptAgent: "Agente IA (cuando el contacto responde)",
            ariaAiEnvironment: "Campaña con asistente de inteligencia artificial",
            promptPlaceholder: "Seleccione un agente…",
            promptPlaceholderSend: "Seleccione agente para el envío masivo…",
            promptPlaceholderReply: "Seleccione agente ante respuesta del contacto…",
            seedBanner:
              "IA generativa activa: se crearán versiones únicas del mensaje por destinatario; los intervalos en el servidor incluyen variación aleatoria.",
            seedLabel: "Mensaje semilla (base)",
            intervalHint: "Con IA dinámica, el sistema aplica jitter en los tiempos de envío sobre los intervalos que indique aquí.",
            tagMandatoryHint: "Con IA dinámica, el etiquetado ante respuesta es obligatorio: active la etiqueta y elija cuál aplicar.",
            autoTagForced: "Activado (obligatorio con IA dinámica)",
            responderTab: "RESPONDER",
            responderTitle: "Ante respuesta del contacto",
            responderBanner:
              "Elija el agente que debe usarse cuando un contacto responde después de esta campaña. Es independiente del que personaliza cada mensaje de envío.",
            attachFileAria: "Adjuntar archivo",
            errors: {
              promptSendRequired: "Seleccione el agente IA para el envío masivo.",
              replyPromptRequired: "Seleccione el agente IA para ante respuesta (pestaña RESPONDER)."
            },
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            restart: "Reiniciar Campañas",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada correctamente",
          cancel: "Campaña cancelada",
          restart: "Campañas reiniciadas",
          deleted: "Registro eliminado",
        },
        report: {
          title: "Informe de",
          status: "Estado",
          validContacts: "Contactos Válidos",
          delivered: "Entregados",
          confirmationRequested: "Confirmaciones Solicitadas",
          confirmations: "Confirmaciones",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          scheduling: "Agendar",
          conclusion: "Conclusión",
          statusValues: {
            inactive: "Inactiva",
            scheduled: "Programada",
            inProgress: "En Progreso",
            cancelled: "Cancelada",
            finished: "Finalizada",
          },
        },
      },
      announcements: {
        active: 'Activo',
        inactive: 'Inactivo',
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada correctamente",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        intervals: "Configuración de Intervalos",
        form: {
          randomTriggerInterval: "Tiempo entre mensajes (segundos)",
          longerIntervalAfter: "Aplicar intervalo mayor después de X mensajes",
          greaterTriggerInterval: "Intervalo mayor entre mensajes (segundos)",
          noInterval: "Sin intervalo",
          notDefined: "No definido",
          seconds: "segundos",
          second: "segundo",
        },
        buttons: {
          addVariable: "AGREGAR VARIABLE",
          saveConfigurations: "GUARDAR CONFIGURACIONES",
          close: "CERRAR",
          add: "AGREGAR",
        },
        variables: {
          shortcut: "Atajo",
          content: "Contenido",
        },
        messages: {
          saveSuccess: "Configuraciones guardadas correctamente",
        },
        help: {
          intervals: "Configura los tiempos de envío para evitar bloqueos de WhatsApp",
          variables: "Crea variables personalizadas para usar en tus mensajes de campaña",
          example: "Ejemplo: Atajo 'empresa' = Contenido 'Mi Empresa S.A.' → Usar {empresa} en mensajes",
        },
      },
      queues: {
        title: "Departamentos",
        toasts: {
          deleted: "Departamento eliminado correctamente",
        },
        table: {
          id: "ID",
          department: "Departamento",
          name: "Nombre",
          color: "Color",
          automation: "Automatización",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Orden de la cola (bot)",
        },
        automationLabels: {
          flowbuilder: "FLOWBUILDER",
          prompt: "PROMPT",
          integration: "INTEGRACIÓN",
          chatbot: "CHATBOT",
          none: "Sin automatización",
        },
        placeholders: {
          noGreeting: "Sin mensaje",
        },
        tooltips: {
          editQueue: "Editar departamento",
          deleteQueue: "Eliminar departamento",
        },
        buttons: {
          add: "Agregar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! Los tickets de este departamento seguirán existiendo pero ya no tendrán ningún departamento asignado.",
        },
      },
      queueOptions: {
        title: "Chatbot con menús de opciones",
        subtitle:
          "Aquí defines los botones que verá el contacto en el chat (menú por niveles). No es un asistente de texto libre: el cliente navega tocando opciones. Usa «Agregar» para cada ítem del menú.",
        add: "Agregar",
        placeholder: {
          title: "Título de la opción",
          message: "Escriba el texto de la opción",
        },
        undefinedTitle: "Título no definido",
      },
      transferQueueModal: {
        title: "Seleccionar Departamento de Transferencia",
        description: "Selecciona el departamento al que se transferirán los tickets cuando el usuario seleccione esta opción.",
        searchPlaceholder: "Buscar departamentos...",
        cancel: "Cancelar",
        confirm: "Confirmar Transferencia",
        noResults: "No se encontraron departamentos con ese nombre",
        noQueues: "No hay departamentos disponibles para transferencia",
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          status: "Estado",
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          department: "Departamento",
          connection: "Conexión",
connectionFromTeam: "por su equipo",
                    connectionNone: "Sin conexión",
                    lastConnection: "Última conexión",
          lastConnectionNow: "Ahora en línea",
          connected: "Conectada",
          disconnected: "Desconectada",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario eliminado correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos del usuario se perderán. Los tickets abiertos de este usuario se moverán al departamento.",
        },
      },
      helps: {
        title: "Centro de Ayuda",
        form: {
          title: "Título",
          videoCode: "URL de Video (YouTube)",
          description: "Descripción",
        },
        table: {
          title: "Título",
          description: "Descripción",
          video: "Video",
        },
        buttons: {
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          saving: "Guardando...",
        },
        formTitle: {
          edit: "Editar Video de Ayuda",
          create: "Crear Nuevo Video de Ayuda",
        },
        sectionVideo: "Información del Video de Ayuda",
        placeholders: {
          video: "https://youtu.be/6FdRJTw46qI o https://tudominio.com/video.mp4",
          thumbnail: "https://tudominio.com/thumbnails/video.jpg",
        },
        helpers: {
          youtubeDetected: "✅ Video de YouTube detectado",
          externalDetected: "✅ Video externo detectado",
          pasteHint:
            "Pega la URL de YouTube o una URL externa de video (ej: https://tudominio.com/video.mp4)",
        },
        thumbnail: {
          label: "URL de Thumbnail (Opcional)",
          hint: "URL opcional de imagen thumbnail personalizada. Si no se proporciona, se usará thumbnail de YouTube o placeholder.",
        },
        grid: {
          emptyTitle: "No hay videos de ayuda registrados",
          emptySubtitle: "Crea tu primer video de ayuda para comenzar",
        },
        tooltips: {
          editRow: "Editar video de ayuda",
        },
        validation: {
          invalidVideoInput:
            "URL de video no válida. Ingresa una URL de YouTube o una URL externa válida (ej: https://tudominio.com/video.mp4)",
          processFailed: "No se pudo procesar la URL del video",
          urlInvalid: "URL no válida. Debe comenzar con http:// o https://",
          urlExtensionHint:
            "La URL no tiene extensión de video. Asegúrate de que el servidor devuelva el Content-Type correcto.",
        },
        toast: {
          youtubeDetected: "Video de YouTube detectado: {{code}}",
          externalDetected: "Video externo detectado y guardado",
        },
        messages: {
          loadError: "No se pudo cargar la lista de registros",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError: "No se pudo realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo realizar la operación",
          deleteTitle: "Eliminación de Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
          videoUnavailable: "El video no está disponible",
          videoLoadError: "No se pudo cargar el video",
          videoLoadHint:
            "El video puede no estar disponible o la URL no es accesible desde este dominio.",
          videoCorsHint:
            "Verifica que el servidor permita acceso público (CORS) y que la URL sea correcta.",
          youtubeError: "Error al cargar el video de YouTube",
          videoUrlError:
            "Error al cargar el video. Verifica que la URL sea accesible y el formato sea compatible.",
          videoNotSupported: "Tu navegador no soporta el elemento de video.",
        },
      },

      uploader: {
        title: "Cargar Logo",
        selectOption: "Seleccionar opción",
        fileInput: "Seleccionar archivo",
        sendFile: "Enviar archivo",
        options: {
          signup: "Página de registro",
          login: "Página de inicio de sesión",
          internal: "Interno",
          favicon: "Favicon",
          favicon256: "Favicon 256x256",
          appleTouch: "Apple Touch Icon",
        },
        messages: {
          noPermission: "No tienes permisos para acceder a esta página",
          invalidFormat: "Formato de archivo no válido. Solo se permiten PNG, ICO y SVG",
          chooseFile: "Por favor, selecciona un archivo",
          chooseDestination: "Por favor, selecciona un destino",
          fileSent: "Archivo enviado correctamente",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Estás seguro que quieres eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no se puede deshacer.",
          deleteAllMessage: "¿Estás seguro que quieres eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          tagName: "Nombre de la etiqueta",
          color: "Color",
          tickets: "Tickets Etiquetados",
          taggedTickets: "Tickets etiquetados",
          kanban: "Kanban",
          origin: "Origen",
          actions: "Acciones",
        },
        kanbanActive: "ACTIVO",
        kanbanInactive: "INACTIVO",
        originProfile: "Por perfil",
        originManual: "Manual",
        readOnly: "Solo lectura",
        profileTagTitle: "Columna Kanban creada al activar Agenda. Solo lectura.",
        manualTagTitle: "Etiqueta creada manualmente",
        readOnlyHint: "Las columnas por perfil no se editan. Cambie el perfil en Agenda > Configuración.",
        columnRenameTitle: "Renombrar columna",
        columnRenamePrompt: "Nuevo nombre para esta columna del tablero:",
        columnRenameHelper: "Solo cambia el texto que se ve; el tablero sigue funcionando igual.",
        columnNameRequired: "El nombre de la columna no puede quedar vacío.",
        columnSaved: "Columna actualizada. Se conservará al recrear el Kanban.",
        columnsReordered: "Orden de columnas guardado.",
        reorderNeedsNoFilter: "Limpia la búsqueda para poder reordenar las columnas.",
        tooltips: {
          editTag: "Editar etiqueta",
          deleteTag: "Eliminar etiqueta",
          renameColumn: "Renombrar columna del tablero",
          hideColumn: "Ocultar columna del tablero",
          showColumn: "Mostrar columna del tablero",
        },
        buttons: {
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
          cancel: "Cancelar",
          save: "Guardar",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas se han eliminado correctamente!",
          deleted: "Etiqueta eliminada correctamente.",
        },
      },
      settings: {
        success: "Configuraciones guardadas correctamente.",
        error: "Error al guardar la configuración.",
        title: "Configuraciones",
        schedules: {
          success: "Horarios guardados correctamente.",
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          version: "Versiones",
          alerts: "Alertas",
          subscriptions: "Suscripciones",
          logo: "Web",
          companies: "Empresas",
          registerCompany: "Registrar Empresa",
          plans: "Planes",
          help: "Ayuda",
          performance: "Rendimiento del Servidor",
        },
        options: {
          userRating: "Calificación de Usuario",
          userRatingDesc: "Permite a los usuarios calificar el servicio recibido",
          userRatingMessageText: "Mensaje de solicitud de calificación",
          userRatingMessageTextDesc:
            "Se envía al cerrar el ticket (junto al texto de la conexión WhatsApp si existe). Máx. 500 caracteres. Mismo criterio que el mensaje de llamadas: no puede quedar vacío al guardar.",
          userRatingMessageTextPlaceholder:
            "Escribe de 1 a 3 para valorar…",
          sendGreetingAcceptedMessageText: "Texto de saludo al aceptar (menú)",
          sendGreetingAcceptedMessageTextDesc:
            "Se usa como saludo del menú de opciones cuando el departamento no tiene mensaje propio. Variables Mustache: {{name}}, {{firstName}}, etc.",
          sendGreetingAcceptedMessageTextPlaceholder: "¡Hola {{name}}! Gracias por contactarnos…",
          transferTicketMessageText: "Mensaje al transferir de departamento",
          transferTicketMessageTextDesc:
            "Solo se envía si «Enviar Mensaje de Transferencia» está habilitado. Variables: {{name}}, {{firstName}} y {queueName} o {{queueName}} para el departamento destino.",
          transferTicketMessageTextPlaceholder: "¡Hola {{name}}! Has sido transferido…",
          greetingOneQueueMessageText: "Saludo con un solo departamento",
          greetingOneQueueMessageTextDesc:
            "Sustituye o complementa el saludo de la conexión cuando solo hay una fila y la opción está activa. Variables Mustache: {{name}}, {{firstName}}, etc. Si lo dejas en blanco al guardar, se restaura el texto por defecto.",
          greetingOneQueueMessageTextPlaceholder: "¡Hola {{name}}! Gracias por escribirnos…",
          scheduleType: "Tipo de Horario",
          ignoreGroupMessages: "Ignorar Mensajes de Grupo",
          acceptCall: "Aceptar Llamadas",
          sendCallAutoMessage: "Enviar Mensaje Automático para Llamadas Deshabilitadas",
          sendCallAutoMessageDesc: "Cuando está habilitado, se envía un mensaje automático cuando las llamadas están deshabilitadas",
          callAutoMessage: "Mensaje Automático para Llamadas",
          callAutoMessageDesc: "Personaliza el mensaje que se enviará automáticamente cuando las llamadas estén deshabilitadas",
          callAutoMessagePlaceholder: "Escribe el mensaje automático (máximo 500 caracteres)",
          restoreDefault: "Restaurar por Defecto",
          preview: "Vista Previa",
          chatbotType: "Tipo de Chatbot",
          sendGreetingAccepted: "Enviar Saludo al Aceptar",
          sendGreetingAcceptedDesc: "Envía saludo automático al aceptar un ticket",
          sendTransferMessage: "Enviar Mensaje de Transferencia",
          sendTransferMessageDesc: "Envía mensaje al transferir ticket entre departamentos",
          teamsEnabled: "Trabajar con subagrupaciones",
          teamsEnabledDesc: "Habilita los equipos de trabajo: aparece la página Subagrupaciones y cada supervisor ve además la cola de su equipo. Con la opción apagada, cada usuario se configura de forma individual.",
          teamsEnabledSaved: "Modo de trabajo actualizado",
          teamsEnabledError: "No se pudo cambiar el modo de trabajo",
                    removeTagsOnCloseTicket: "Quitar etiquetas al cerrar",
          removeTagsOnCloseTicketDesc:
            "Si está habilitado, al cerrar un ticket se eliminan todas sus etiquetas y se pedirá confirmación antes de cerrar",
          reopenTicketToBot: "Devolver al bot al reabrir",
          reopenTicketToBotDesc:
            "Si está habilitado, cuando el contacto escribe a un ticket cerrado, este vuelve al departamento por defecto de la conexión y a su bot, sin agente (pasados los minutos de espera configurados). Si está deshabilitado, conserva el departamento anterior",
          reopenTicketToBotMinutes: "Minutos de espera antes de devolver al bot",
          reopenTicketToBotMinutesDesc:
            "Si el contacto vuelve a escribir antes de que pasen estos minutos desde el cierre, el ticket regresa a su mismo departamento para que lo siga atendiendo un agente. Pasado ese tiempo, lo atiende el bot. Use {minutos} en el mensaje de cierre para mostrar este valor. No es la «Transferencia por tiempo» de la conexión.",
          reopenTicketToBotMinutesLabel: "Minutos",
          reopenTicketToBotMinutesHelper: "0 = el bot atiende de inmediato (máx. 1440)",
          reopenTicketToBotMinutesError: "No se pudieron guardar los minutos de espera",
          reopenGraceMessage: "Aviso al volver a escribir dentro de la espera",
          reopenGraceMessageDesc:
            "Se envía una sola vez al contacto que escribe antes de que venzan los minutos de espera, para que sepa que un agente lo atenderá. Si nadie lo atiende y vuelve a escribir pasado ese tiempo, lo atiende el bot. Variables: {departamento}, {minutos}, {nroticket}. Déjelo vacío para no enviar aviso.",
          reopenGraceMessageError: "No se pudo guardar el aviso",
          sendTicketCloseMessage: "Mensaje al cerrar ticket",
          sendTicketCloseMessageDesc:
            "Envía un mensaje de WhatsApp al cliente al cerrar el ticket (no aplica a grupos). Use {nroticket} para el número de ticket y {minutos} para los minutos de espera antes de devolver al bot",
          ticketCloseMessageText: "Texto del mensaje al cerrar",
          ticketCloseMessageTextDesc:
            "Mismo criterio que el mensaje automático de llamadas: texto obligatorio (máx. 500 caracteres), editable y con botón «Restaurar por defecto». Variables: {nroticket} = ID del ticket; {minutos} = minutos de espera antes de devolver al bot. Se envía tras el cierre confirmado.",
          ticketCloseMessageTextPlaceholder:
            "💬⚙️ *Ticket de Atención:* {nroticket} 😀 ya fue cerrado. Si necesitas algo más en los próximos {minutos} minutos, te seguimos atendiendo; después te atenderá nuestro asistente 🤖.",
          sendGreetingOneQueue: "Enviar Saludo con Un Departamento",
          sendGreetingOneQueueDesc: "Envía saludo cuando hay solo una fila disponible",
          globalSettings: "Configuraciones Globales",
          registrationAllowed: "Registro Permitido",
          registrationVisible: "Registro Visible",
          trialTime: "Tiempo de Prueba",
          mainSettings: "Configuraciones Principales",
          messagingSettings: "Configuraciones de Mensajería",
          customerMessageLocale: "Idioma de mensajes automáticos al cliente (WhatsApp)",
          customerMessageLocaleDesc:
            "Idioma de saludos, transferencias, plantillas y textos automáticos que recibe el contacto por WhatsApp. Es independiente del idioma del panel de cada operador.",
          scheduleTypeDesc: "Define el tipo de horario de atención",
          ignoreGroupMessagesDesc: "Ignora mensajes de grupos de WhatsApp",
          chatbotTypeDesc: "Tipo de chatbot para respuestas automáticas",
          internalSignature: "Firmas Internas",
          internalSignatureDesc: "Muestra automáticamente el nombre del usuario que envía cada mensaje (solo visible internamente)",
          validateWhatsAppNumbers: "Validar Números de WhatsApp",
          validateWhatsAppNumbersDesc: "Valida si los números están en WhatsApp al importar listas de contactos. Si está desactivado, se procesan todos los números sin validación.",
          timezoneForCampaigns: "Zona Horaria para Campañas",
          timezoneForCampaignsDesc: "Selecciona tu zona horaria para campañas masivas",
          timezone: "Zona Horaria",
          callAutoMessageMaxLength: "El mensaje no puede exceder 500 caracteres",
          callAutoMessageSaveError: "Error al guardar el mensaje",
          characters: "caracteres",
          registrationAllowedDesc: "Permite el registro de nuevos usuarios",
          registrationVisibleDesc: "Muestra el formulario de registro públicamente",
          trialTimeDesc: "Días de prueba para nuevos usuarios",
          day: "día",
          days: "días",
          additionalSettings: "Configuraciones Adicionales",
          webInfo: "Info. Web",
          websiteTitle: "Título del sitio web",
          websiteTitleDesc: "Título que aparecerá en la pestaña del navegador y en los resultados de búsqueda",
          websiteDescription: "Descripción del sitio web",
          websiteDescriptionDesc: "Descripción que aparecerá en los resultados de búsqueda y redes sociales",
          websiteKeyword: "Palabra clave del sitio web",
          websiteKeywordDesc: "Palabras clave principales para SEO y posicionamiento web",
          companyName: "Nombre de la empresa",
          companyNameDesc: "Nombre de la empresa que aparecerá en el copyright del login",
          companyNameCopyright: "Nombre de la empresa (Copyright)",
          logos: "Logos",
          exampleCliqueaCRM: "Ejemplo: Cliquea CRM",
          exampleAutomatiza: "Ejemplo: Automatiza, conecta y ¡Vende más!",
          exampleWhatsAppAPI: "Ejemplo: WHATSAPP API",
          exampleWatoolx: "Ejemplo: watoolx.com",
          localeEs: "Español",
          localeEn: "English",
          localePt: "Português",
          loadingTimezones: "Cargando zonas horarias…",
          timezoneQuickPeru: "Perú (America/Lima)",
          timezoneQuickColombia: "Colombia (America/Bogota)",
          ariaSectionMain: "Configuraciones principales",
          ariaSectionMessaging: "Configuraciones de mensajería",
        },
        states: {
          disabled: "Deshabilitado",
          enabled: "Habilitado",
          activated: "Activado",
          deactivated: "Desactivado",
          accept: "Aceptar",
          notAccept: "No Aceptar",
          text: "Texto",
          updating: "Actualizando...",
          yes: "Sí",
          no: "No",
          queue: "Departamento",
          company: "Empresa",
        },
        versionPage: {
          loading: "Cargando información de versión…",
          title: "Información de versión del sistema",
          ariaVersion: "Versión",
          currentVersion: "Versión actual",
          changelogChip: "changelog {{version}}",
          releaseDateChangelog: "Fecha release (CHANGELOG):",
          changeType: "Tipo de cambio",
          milestoneTitle: "Hito arquitectónico",
          milestoneDefault: "Evolución de monolito a arquitectura hexagonal modular y saneamiento total de deuda técnica. Base para Meta Cloud API y nuevos canales.",
          gitDateChip: "Fecha vía Git",
          releaseSummary: "Resumen del último release",
          viewFullHistory: "Ver historial completo →",
          changesCount: "{{count}} cambios",
          frontendVersion: "Versión frontend",
          apiVersion: "Versión API (paquete backend)",
          baseWhaticket: "Base Whaticket:",
          lastUpdate: "Última actualización",
          semanticFooter: "Sistema de versionado semántico implementado",
          fullHistory: "Ver historial completo →",
          na: "N/D",
        },
        subscriptionsPayment: {
          title: "Métodos de pago",
          intro:
            "Configura las credenciales de PayPal y Stripe para habilitar pagos recurrentes. ",
          introNote:
            "Nota: Tras guardar, reinicia el servidor backend para aplicar los cambios.",
          saving: "Guardando…",
          sectionPaypal: "PayPal",
          sectionStripe: "Stripe",
          sectionCurrency: "Moneda",
          paypalClientIdLabel: "ID de cliente PayPal",
          paypalClientIdDesc: "ID de cliente de tu aplicación PayPal",
          paypalClientIdField: "PayPal Client ID",
          paypalClientIdHelper:
            "Ejemplo: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
          paypalSecretLabel: "Secreto de cliente PayPal",
          paypalSecretDesc: "Secreto de tu aplicación PayPal",
          paypalSecretField: "PayPal Client Secret",
          paypalSecretHelper: "Secreto de tu aplicación PayPal",
          paypalModeLabel: "Modo de PayPal",
          paypalModeDesc: "Sandbox (pruebas) o live (producción)",
          modeField: "Modo",
          modeSandbox: "Sandbox (pruebas)",
          modeLive: "Live (producción)",
          stripeKeyLabel: "Clave secreta Stripe",
          stripeKeyDesc: "Clave secreta de tu cuenta Stripe (sk_test_… o sk_live_…)",
          stripeKeyField: "Stripe Secret Key",
          stripeKeyHelper: "Ejemplo: sk_test_51AbCdEf…",
          stripeWebhookLabel: "Webhook secret Stripe",
          stripeWebhookDesc: "Secreto del webhook para verificar eventos (whsec_…)",
          stripeWebhookField: "Stripe Webhook Secret",
          stripeWebhookHelper: "Ejemplo: whsec_1234567890abcdef",
          currencyLabel: "Moneda preferida",
          currencyDesc: "Moneda mostrada en planes y facturas",
          currencyField: "Moneda",
          currencyUSD: "USD — Dólar estadounidense ($)",
          currencyEUR: "EUR — Euro (€)",
          currencyGBP: "GBP — Libra esterlina (£)",
          currencyBRL: "BRL — Real brasileño (R$)",
          currencyMXN: "MXN — Peso mexicano ($)",
          currencyARS: "ARS — Peso argentino ($)",
          currencyCLP: "CLP — Peso chileno ($)",
          currencyCOP: "COP — Peso colombiano ($)",
          currencyPEN: "PEN — Sol peruano (S/)",
          toastPaypalId: "PayPal Client ID guardado correctamente",
          toastPaypalSecret: "PayPal Client Secret guardado correctamente",
          toastPaypalMode: "Modo PayPal actualizado correctamente",
          toastStripeKey: "Stripe Secret Key guardado correctamente",
          toastStripeWebhook: "Stripe Webhook Secret guardado correctamente",
          toastCurrency: "Moneda actualizada correctamente",
        },
        vpsAlerts: {
          validation: {
            emailConnectionSelect: "Conexión de correo: elige por cuál salen las alertas en «Conexión de correo *».",
            adminEmailRequired:
              "Email del administrador: campo obligatorio cuando usas correo.",
            adminEmailInvalid:
              "Email del administrador: el formato no es válido.",
            whatsappSelect:
              "Conexión WhatsApp: elige una línea en el desplegable «Conexión WhatsApp *» (vacío impide guardar y no se envía nada al servidor).",
            adminWhatsappRequired:
              "Número de WhatsApp del administrador: campo obligatorio cuando usas WhatsApp.",
            adminWhatsappInvalid:
              "Número de WhatsApp: usa 10 a 15 dígitos; puedes anteponer +.",
            whatsappTemplateRequired:
              "Plantilla de mensaje WhatsApp: no puede estar vacía.",
          },
          validationModal: {
            bodyIntro:
              "No se ha enviado la petición al servidor. Completa lo siguiente:",
            titleTest: "Faltan datos para la prueba",
            titleSave: "No se puede guardar: formulario incompleto",
          },
          notes: {
            noEmailConnection: "Nota: no hay ninguna conexión de correo. Créala en Conexiones → Agregar → Correo electrónico.",
            noConnectedWhatsapp:
              "Nota: no hay WhatsApp en estado CONECTADO; revisa «Conexiones».",
          },
          test: {
            lineEmailOk: "✅ Email enviado exitosamente",
            lineWhatsappOk: "✅ WhatsApp enviado exitosamente",
            successIntro: "Notificación de prueba enviada exitosamente:",
            footerEmail: "Revisa tu email para confirmar la recepción.",
            footerWhatsapp: "Revisa tu WhatsApp para confirmar la recepción.",
            footerBoth:
              "Revisa tu email y WhatsApp para confirmar la recepción.",
            errorIntro: "Error al enviar notificación de prueba:",
            unknownError: "Error desconocido",
          },
          save: {
            notSavedTitle: "No se guardó la configuración",
            notSavedBody:
              "Revisa el mensaje de error en pantalla (si aparece) y tu conexión. Si el problema continúa, inténtalo de nuevo en unos segundos.",
            successTitle: "✅ Configuración Guardada",
            successBody:
              "La configuración de notificaciones VPS se ha guardado exitosamente.",
            errorTitle: "❌ Error al Guardar",
            errorBody: "Error al guardar la configuración: {{message}}",
          },
          loadError:
            "No se pudo cargar la configuración de alertas VPS: {{error}}. Comprueba que tu usuario sea administrador, que la API esté disponible y que existan los objetos de BD (VPSNotificationConfig, SP).",
          retry: "Reintentar",
          generalSection: "Habilitación General",
          toggleLabel: "Habilitar sistema de alertas y limpieza automática",
          infoWhyTitle: "¿Por qué habilitar este sistema?",
          infoIntro:
            "Este sistema de alertas y limpieza automática es especialmente útil si:",
          infoLi1: "Tu negocio maneja miles de mensajes WhatsApp diarios",
          infoLi2: "Generas muchos registros en la base de datos",
          infoLi3: "Necesitas monitoreo proactivo del servidor",
          infoLi4: "Quieres prevenir problemas de disco lleno",
          infoClosing:
            "Recomendado mantenerlo activado: la limpieza de binary logs evita que se llene el disco aunque no configures notificaciones.",
          warningEnabled:
            "IMPORTANTE: las notificaciones son opcionales. Sin canal («Ninguna»), el sistema aplica los umbrales y la limpieza en silencio; elige Email o WhatsApp solo si quieres recibir avisos.",
          notificationsSection: "Configuración de Notificaciones",
          channelEmail: "Email",
          channelWhatsapp: "WhatsApp",
          channelBoth: "Ambos",
          channelNone: "Ninguna (solo umbrales y limpieza)",
          emailSection: "Configuración Email",
          emailConnectionLabel: "Conexión de correo *",
          emailConnectionHint: "Por esta conexión salen las alertas y también la recuperación de contraseña. Se aplica al elegirla.",
          noEmailConnection: "No existe ninguna conexión de correo. Crea una en Conexiones → Agregar → Correo electrónico para recibir las alertas por correo.",
          goToConnections: "Ir a Conexiones",
          selectEmailConnection: "Elegir conexión…",
          emailTemplateOptional: "Plantilla de Email (Opcional)",
          useDefaultTemplates: "Usar plantillas por defecto",
          adminEmailLabel: "Email del Administrador *",
          invalidEmail: "Formato de email inválido",
          adminEmailHint: "Email donde recibirás las alertas",
          whatsappSection: "Configuración WhatsApp",
          whatsappConnectionLabel: "Conexión WhatsApp *",
          selectWhatsapp: "Seleccionar WhatsApp...",
          whatsappTemplateLabel: "Plantilla de Mensaje WhatsApp",
          whatsappTemplateVars:
            "Variables disponibles: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
          adminWhatsappLabel: "Número de WhatsApp del Administrador *",
          invalidWhatsapp:
            "Formato inválido (10-15 dígitos, opcionalmente precedido por +)",
          adminWhatsappHint:
            "Número donde recibirás las alertas (con código de país)",
          thresholdsSection: "Umbrales de Alertas",
          diskPct: "Disco (%)",
          diskHelp: "Alerta cuando el uso de disco supere este porcentaje",
          binaryGb: "Binary Logs (GB)",
          binaryHelp: "Alerta cuando el tamaño de binary logs supere este valor",
          cpuPct: "CPU (%)",
          cpuHelp: "Alerta cuando el uso de CPU supere este porcentaje",
          memPct: "Memoria (%)",
          memHelp: "Alerta cuando el uso de memoria supere este porcentaje",
          enableDisk: "Habilitar alertas de disco",
          enableBinary: "Habilitar alertas de binary logs",
          enableCpu: "Habilitar alertas de CPU",
          enableMem: "Habilitar alertas de memoria",
          enableCritical: "Habilitar alertas críticas",
          frequencySection:
            "Frecuencia de Notificaciones y Limpieza Automática",
          alertFreqLabel: "Frecuencia de Alertas (horas)",
          alertFreqHelp:
            "Cada cuántas horas se enviarán alertas automáticas (1-48 horas)",
          cleanupSubtitle: "Limpieza automática del servidor",
          cleanupInfoTitle: "Qué hace esta sección (importancia)",
          cleanupInfoIntro:
            "Con la limpieza activada, el sistema puede ejecutar acciones de mantenimiento sin intervención manual:",
          cleanupInfoLi1:
            "Si el disco supera el umbral (%): se aplica la rutina completa (purga de binary logs según política del servidor, pasos iterativos y optimización de tablas críticas cuando haga falta).",
          cleanupInfoLi2:
            "Si el disco está por debajo del umbral pero los binary logs de MySQL superan el umbral (GB): se ejecuta una purga progresiva de logs (conservadora y luego más agresiva), típica cuando el disco total es grande y el porcentaje no sube, pero los binlogs crecen mucho.",
          cleanupRisk:
            "Riesgo operativo: la purga de binary logs afecta la ventana de recuperación punto-en-tiempo (PITR). Use umbrales acordes a su política de backups y réplicas MySQL.",
          enableAutoCleanup: "Habilitar limpieza automática",
          enableDiskAutoCleanup: "Incluir limpieza por disco (optimiza tablas)",
          diskCleanupHelp: "Al superar el umbral de disco purga binary logs y ejecuta OPTIMIZE TABLE hasta bajar de él. Puede bloquear tablas grandes durante minutos: actívala solo si sabes que la necesitas.",
          cleanupCooldownNote:
            "Frecuencia de alertas ({{hours}} h) también limita cuánto puede repetirse la limpieza disparada solo por binary logs (GB) (cooldown desde la última ejecución de ese tipo).",
          cleanupDiskThreshold: "Umbral de disco para limpieza (%)",
          cleanupDiskHelp:
            "Si el uso de disco llega a este %, se ejecuta la rutina completa de limpieza (binlogs + pasos adicionales según BD).",
          cleanupBinlogGb: "Umbral de binary logs para limpieza (GB)",
          cleanupBinlogHelp:
            "Si el tamaño estimado de binary logs ≥ este valor y el disco NO disparó la rutina anterior, se purgan logs de forma progresiva. Suele ser menor que el umbral de solo alerta (GB).",
          lastCleanup:
            "Última limpieza automática por umbral de binary logs: {{date}}",
          saveConfig: "Guardar Configuración",
          saving: "Guardando...",
          sendTest: "Enviar Notificación de Prueba",
          sending: "Enviando...",
          testModal: {
            sending: "Enviando Notificación de Prueba...",
            success: "✅ Notificación Enviada",
            error: "❌ Error al Enviar",
            pleaseWait:
              "Por favor espera mientras se envía la notificación...",
            tipPrefix: "Tip:",
            tipEmail:
              "Revisa tu email para confirmar la recepción.",
            tipWhatsapp:
              "Revisa tu WhatsApp para confirmar la recepción.",
            tipBoth:
              "Revisa tu email y WhatsApp para confirmar la recepción.",
            close: "Cerrar",
            cancel: "Cancelar",
          },
          accept: "Aceptar",
          defaultWhatsAppTemplate:
            "⚠️ ALERTA VPS: {alertType}\n📊 Estado del Sistema:\n💾 Disco: {diskUsage}%\n📝 Binary Logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memoria: {memoryUsage}%\n\n{message}",
        },
      },
      messagesList: {
        deletedByContact: "Este mensaje fue eliminado por el contacto",
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Volver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
        reactions: {
          you: "Tú",
          contact: "Contacto",
          reacted: "reaccionó"
        }
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed:
          "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        mediaCaptionPlaceholder:
          "Añade un mensaje… (opcional — se envía junto al archivo)",
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Información adicional",
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        dragDrop: {
          sectionTitle: "Lista de archivos",
          main: "Arrastra y suelta tus archivos aquí",
          sub: "o haz clic para seleccionar archivos",
          formats:
            "Formatos admitidos: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
        },
        table: {
          thumbnail: "Miniatura",
          name: "Nombre",
          format: "Formato",
          size: "Peso",
          type: "Tipo",
          actions: "Acciones",
        },
        validation: {
          nameMin: "Nombre demasiado corto",
          required: "Obligatorio",
        },
        fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
        tooltips: { removeFile: "Eliminar archivo" },
        success: "Lista de archivos guardada correctamente!",
      },
      ticketOptionsMenu: {
        schedule: "Agendar",
        openInNewWindow: "Abrir conversación en nueva pestaña",
        openInNewUnavailable: "Este ticket no tiene UUID; no se puede abrir en otra pestaña.",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Inserta aquí la información que deseas registrar",
        },
        confirmationModal: {
          title: "Eliminar el ticket",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        forward: "Reenviar",
        edit: "Editar",
        react: "Reaccionar",
        reply: "Responder",
        delete: "Eliminar",
        reactionSuccess: "Reacción agregada exitosamente",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede deshacer.",
        },
        editMessageModal: {
          title: "Editar mensaje"
        }
      },
      backendErrors: {
        ERR_CAMPAIGN_EMAIL_NOT_SUPPORTED: "Las campañas no se envían por una conexión de correo. Elige una conexión de WhatsApp.",
        ERR_EMAIL_NOT_SUPPORTED: "Esta acción no existe en el correo electrónico.",
        ERR_EMAIL_AUTH_FAILED: "Gmail rechazó el correo o la contraseña de aplicación.",
        ERR_EMAIL_SEND_FAILED: "No se pudo enviar el correo. Inténtalo de nuevo.",
        ERR_EMAIL_COMPOSE_INVALID_CC: "Revisa las direcciones de «CC»: alguna no es válida (máximo 20).",
        ERR_EMAIL_COMPOSE_INVALID_BCC: "Revisa las direcciones de «CCO»: alguna no es válida (máximo 20).",
        ERR_EMAIL_COMPOSE_INVALID_TO: "Escribe una dirección de correo válida en «Para».",
        ERR_EMAIL_COMPOSE_SUBJECT_REQUIRED: "Escribe el asunto del correo.",
        ERR_EMAIL_COMPOSE_SUBJECT_TOO_LONG: "El asunto no puede superar 200 caracteres.",
        ERR_EMAIL_COMPOSE_BODY_REQUIRED: "Escribe el mensaje del correo.",
        ERR_EMAIL_COMPOSE_CONNECTION_REQUIRED: "Elige la conexión de correo por la que enviar.",
        ERR_EMAIL_COMPOSE_NOT_EMAIL: "La conexión elegida no es de correo.",
        ERR_EMAIL_COMPOSE_QUEUE_NOT_FOUND: "El departamento elegido no existe.",
        ERR_EMAIL_INVALID_ADDRESS: "La dirección de correo no es válida.",
        ERR_EMAIL_ACCOUNT_NOT_FOUND: "No se encontró esa conexión de correo.",
        ERR_EMAIL_NOT_SUPER: "Solo el superadministrador puede elegir el buzón del sistema.",
        ERR_EMAIL_NO_SYSTEM_MAILBOX: "Ninguna conexión de correo envía los correos del sistema. Elígela en Configuración → Alertas.",
        ERR_EMAIL_TEMPLATE_NOT_FOUND: "No se encontró esa plantilla.",
        ERR_EMAIL_TEMPLATE_SUBJECT_REQUIRED: "La plantilla necesita un asunto.",
        ERR_EMAIL_TEMPLATE_BODY_REQUIRED: "La plantilla necesita contenido HTML.",
        ERR_SYNC_POLICY_INVALID_MODE: "Modo de historial no válido.",
        ERR_SYNC_POLICY_INVALID_DAYS: "El historial solo puede ser de 7, 15 o 30 días.",
        ERR_SYNC_POLICY_INVALID_MAX: "El tope de mensajes por chat debe estar entre 1 y 1000.",
        ERR_SYNC_POLICY_NOT_BAILEYS: "El historial solo se configura en conexiones API Baileys.",
        ERR_SYNC_POLICY_CONNECTION_NOT_FOUND: "No se encontró la conexión.",
        ERR_TELEGRAM_CHANNEL_DISABLED: "El canal Telegram no está habilitado en esta plataforma.",
        ERR_TELEGRAM_INVALID_TOKEN: "El token del bot no es válido o fue revocado. Cópialo de nuevo desde @BotFather.",
        ERR_TELEGRAM_API_UNREACHABLE: "No se pudo contactar con Telegram. Inténtalo de nuevo en unos minutos.",
        ERR_TELEGRAM_WEBHOOK_REJECTED: "Telegram rechazó la dirección del servidor. El backend necesita una URL pública con HTTPS.",
        ERR_TELEGRAM_ACCOUNT_IN_USE: "Esa cuenta de Telegram ya está conectada en otra conexión.",
        ERR_TELEGRAM_RESPONSIBILITY_NOT_ACCEPTED: "Para conectar tu cuenta personal tienes que aceptar el aviso de responsabilidad.",
        ERR_TELEGRAM_NOT_CONFIGURED: "La plataforma todavía no tiene configurado el acceso a Telegram. Contacta con el administrador.",
        ERR_TELEGRAM_NOT_USER_CONNECTION: "Esta conexión no es de una cuenta personal de Telegram.",
        ERR_TELEGRAM_NOT_WAITING_PASSWORD: "Telegram no está esperando la contraseña ahora mismo. Genera un QR nuevo.",
        ERR_TELEGRAM_NAME_REQUIRED: "Escribe un nombre para la conexión.",
        ERR_TELEGRAM_PASSWORD_REQUIRED: "Escribe la contraseña de verificación en dos pasos.",
        ERR_TELEGRAM_BOT_IN_USE: "Ese bot ya está conectado en otra conexión. Un bot de Telegram solo puede estar en una.",
        ERR_TELEGRAM_TOKEN_IN_USE: "Ese token ya está en uso en otra conexión.",
        ERR_TELEGRAM_BOT_NOT_FOUND: "Esta conexión no tiene un bot de Telegram configurado.",
        ERR_TELEGRAM_CHAT_NOT_REACHABLE: "No se puede escribir a este contacto por Telegram: no inició la conversación con el bot o lo bloqueó.",
        ERR_CAMPAIGN_TELEGRAM_NOT_SUPPORTED: "Las campañas no están disponibles para conexiones de Telegram.",
        ERR_TRANSFER_SIN_DESTINO: "Elegí un departamento o una persona: el ticket no puede quedar sin destino.",
        ERR_TRANSFER_FUERA_DE_EQUIPO: "Esa persona es de otro equipo. Podés derivar el ticket a su departamento, o pedirle a tu supervisor que lo mueva.",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró ningún WhatsApp predeterminado. Comprueba la página de conexiones.",
        ERR_WAPP_DUP_NAME: "Ese nombre ya está siendo utilizado por otra conexión.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no se ha inicializado. Comprueba la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Comprueba la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_CHECK_NUMBER_EMPTY_RESPONSE: "El número no está registrado en WhatsApp, pero el contacto se creó exitosamente.",
        ERR_CHECK_NUMBER: "El número no está registrado en WhatsApp, pero el contacto se creó exitosamente.",
        NUMBER_NOT_IN_WHATSAPP: "El contacto se guardó exitosamente, pero el número no está registrado en WhatsApp.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudo descargar medios de WhatsApp. Comprueba la página de conexiones.",
        ERR_INVALID_CREDENTIALS:
          "Error de autenticación. Por favor, inténtalo de nuevo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar mensaje de WhatsApp. Comprueba la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_TICKET_NEEDS_CONFIRMATION: "Ticket existe sin departamento. ¿Desea asignar este departamento?",
        ERR_TICKET_EXISTS_WITH_DIFFERENT_QUEUE: "Ya existe un ticket abierto con el departamento {{queueName}}.",
        ERR_TICKET_EXISTS_WITH_QUEUE: "Ya existe un ticket abierto con departamento asignado.",
        ERR_QUEUE_REQUIRES_WHATSAPP: "Debe seleccionar una conexión cuando asigna un departamento.",
        ERR_CONTACT_ID_REQUIRED: "Debe seleccionar un contacto para crear el ticket",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicia sesión.",
        ERR_TOO_MANY_ATTEMPTS: "Demasiados intentos. Espera unos minutos y vuelve a probar.",
        ERR_RESET_EMAIL_REQUIRED: "Escribe tu correo electrónico.",
        ERR_RESET_TOKEN_INVALID: "El enlace no es válido. Pide uno nuevo.",
        ERR_RESET_TOKEN_EXPIRED: "El enlace caducó. Pide uno nuevo.",
        ERR_RESET_TOKEN_USED: "Este enlace ya se usó. Pide uno nuevo.",
        ERR_RESET_PASSWORD_TOO_SHORT: "La contraseña debe tener al menos 8 caracteres.",
        ERR_RESET_PASSWORD_TOO_LONG: "La contraseña es demasiado larga (máximo 128 caracteres).",
        ERR_TOO_MANY_REQUESTS: "El panel está haciendo demasiadas peticiones con tu usuario. Espera unos segundos y vuelve a intentarlo. Si tu cuenta está abierta en varias pestañas o equipos, cierra las que no uses.",
        ERR_PAYLOAD_TOO_LARGE: "Los datos enviados son demasiado grandes.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios ha sido deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con esta ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con esta ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con esta ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con esta ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con esta ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener mensaje de WhatsApp, puede que sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elige otro.",
        ERR_QUEUE_NAME_ALREADY_EXISTS:
          "Este nombre de departamento ya existe, elige otro.",
        ERR_COMPANY_NAME_ALREADY_EXISTS:
          "Ya existe una empresa con este nombre. Por favor, elige otro nombre.",
        ERR_COMPANY_INVALID_NAME:
          "El nombre de la empresa es inválido. Debe tener entre 2 y 50 caracteres.",
        ERR_NO_PLAN_CONFIGURED:
          "No hay planes configurados en el sistema. Contacte al administrador.",
        ERR_COMPANY_CREATION_FAILED:
          "No se pudo crear la empresa. Verifique los datos o contacte al soporte.",
        ERR_WAPP_GREETING_REQUIRED:
          "El saludo es obligatorio cuando hay más de un departamento.",
        // ✅ NUEVOS ERRORES DEL BACKEND
        ERR_PDF_SEND_FAILED: "No se pudo enviar el PDF, inténtalo nuevamente!",
        ERR_MESSAGE_NOT_PROCESSABLE: "Mensaje no procesable",
        ERR_UNRECOGNIZED_MESSAGE: "Mensaje no reconocido",
        ERR_TEMPORARY_MESSAGE: "Mensaje temporal",
        ERR_EPHEMERAL_MESSAGE_PROCESSING: "Error al procesar mensaje temporal",
        ERR_INTERNAL_SERVER: "Error interno del servidor. Inténtalo de nuevo o contacta a soporte.",
        ERR_DB_VALIDATION: "Los datos no cumplen las reglas de validación en base de datos.",
        ERR_TICKET_UPDATE_FAILED: "No se pudo actualizar el ticket. Inténtalo de nuevo.",
        ERR_SETTING_FOREIGN_COMPANY: "No puedes modificar la configuración de otra empresa.",
        ERR_NO_WBOT_FOR_WHATSAPP:
          "No hay sesión de WhatsApp activa para la conexión {{whatsappId}}. Revisa la página de conexiones.",
        ERR_UNKNOWN: "Ha ocurrido un error inesperado.",
      },
      welcome: {
        message: "¡Hola {name}, Bienvenido a {company}!",
        activeUntil: "Activo hasta {date}",
      },
      version: "Versión: {version}",
      logout: "Salir",
      time: {
        hoursAgo: "{hours} h atrás",
        minutesAgo: "{minutes} min atrás",
        daysAgo: "{days} días atrás",
      },
      confirmationModal: {
        buttons: {
          cancel: "Cancelar",
          confirm: "Confirmar",
        },
      },
      hardcodedElements: {
        atendimento: "Atenciones",
        tarefas: "Tareas",
        gerencia: "Gestión",
        campanhas: "Campañas",
        listagem: "Envío de mensajes",
        configuracoes: "Tiempos de Envío",
        administracao: "Administración",
        semFila: "Sin departamento",
        sair: "Salir",
        sayHelloToNewContact: "¡Hola! ¿En qué puedo ayudarte?",
        admin: "Administrador",
        filas: "Filas",
        todos: "Todos",
        hey: "hey",
      },
      financial: {
        title: "Facturación",
        pageTitle: "Facturación y suscripciones",
        tabs: {
          subscriptions: "Suscripciones",
          invoices: "Facturas",
          management: "Gestión",
        },
        table: {
          id: "ID",
          details: "Detalles",
          value: "Valor",
          dueDate: "Fecha Venc.",
          status: "Estado",
          action: "Acción",
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "En Abierto",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
        },
        messages: {
          noInvoices: "No hay facturas para mostrar",
          paymentSuccess: "Pago procesado exitosamente",
          paymentError: "Error al procesar el pago",
        },
        subscription: {
          planDetails: "Detalles del plan",
          usersLabel: "Usuarios",
          billingMonthly: "Facturación: Mensual",
          title: "Suscripción",
          checkoutSuccess: "Suscripción realizada con éxito. Esperando la confirmación del pago",
          currentPlanLabel: "Plan actual",
          noPlanAssigned: "Sin plan asignado",
          availablePlans: "Planes disponibles",
          availablePlansHint:
            "Selecciona un plan para suscribirte. Podrás pagar con PayPal o Stripe.",
          perMonth: "/mes",
          users_one: "{{count}} usuario",
          users_other: "{{count}} usuarios",
          connections_one: "{{count}} conexión WhatsApp",
          connections_other: "{{count}} conexiones WhatsApp",
          queues_one: "{{count}} fila",
          queues_other: "{{count}} filas",
          featureCampaigns: "Campañas",
          featureSchedules: "Programación",
          featureOpenAi: "Inteligencia artificial",
          subscribe: "Suscribirse",
          processing: "Procesando...",
          noPlansTitle: "No hay planes disponibles",
          noPlansHint: "Contacta al administrador para más información",
        },
      },
      kanban: {
        open: "En Abierto",
        tagNotFound: "Etiqueta no encontrada.",
        cannotMapStatus: "No se puede mapear la columna al estado de la cita.",
        theContact: "el contacto",
        confirmMoveConfirmed: "Vas a confirmar la cita de {{name}} y se le enviará un WhatsApp avisándole.",
        confirmMoveCompleted: "Vas a dar por completada la cita de {{name}} y se le enviará el mensaje de seguimiento.",
        confirmMoveCancelled: "Vas a cancelar la cita de {{name}} y se le enviará un WhatsApp avisándole.",
        confirmMoveTitle: "Confirmar movimiento",
        columnsReordered: "Orden de columnas guardado.",
        dragColumnHint: "Arrastra la cabecera para reordenar esta columna",
        confirmMoveIrreversible: "El mensaje no se puede deshacer. ¿Continuar?",
        moveNotAllowed: "Ese movimiento no está permitido para el estado actual de la cita.",
        unassignedOwner: "Sin asignar",
        attendedByAI: "Atendido por {{name}}",
        appointmentUpdated: "Cita actualizada.",
        ticketMoved: "Ticket movido correctamente.",
        moveError: "Error al mover la tarjeta.",
        configureAgendaHint:
          "Configura Agenda en Configuración para ver el Kanban por perfil.",
      },
      // ✅ NUEVAS TRADUCCIONES PARA REPORTE DE ETIQUETAS
      tagsReport: {
        title: "ETIQUETAS POR PERIODO",
        filters: {
          start: "Inicio",
          end: "Fin",
          filter: "FILTRAR",
        },
        messages: {
          loading: "Cargando datos...",
          noData: "No hay datos de etiquetas para el período seleccionado",
          error: "Error al cargar el reporte de etiquetas",
        },
        chart: {
          yAxisTitle: "Número de Tickets",
          xAxisTitle: "Etiquetas",
          tooltip: "tickets",
        },
      },
      updateVersion: {
        title: "Actualizar Versión",
        buttons: {
          check: "Verificar",
          close: "Cerrar",
          update: "Actualizar Sistema",
        },
        status: {
          checking: "Verificando actualizaciones...",
          upToDate: "Sistema actualizado",
          updatesAvailable: "Nuevas actualizaciones disponibles",
          error: "Error al verificar actualizaciones",
          updating: "Actualización completa en progreso...",
          completed: "Actualización completada",
        },
        messages: {
          currentVersion: "Versión actual:",
          latestVersion: "Última versión disponible:",
          commitsAhead: "Hay {count} nuevos commits disponibles.",
          checkUpdates: "Haz clic en 'Verificar' para comprobar si hay actualizaciones disponibles.",
          updateInProgress: "Actualización en progreso...",
          updateCompleted: "Actualización completada exitosamente",
          pageWillReload: "La página se recargará automáticamente en unos segundos...",
          newVersion: "Nueva versión:",
          updateMessage: "Mensaje:",
          updateAuthor: "Autor:",
          stepsCompleted: "Pasos completados:",
          processMayTakeMinutes: "Este proceso puede tomar varios minutos...",
        },
        errors: {
          noUpdates: "No hay actualizaciones disponibles",
          updateFailed: "Error durante la actualización",
          localChanges: "Hay cambios locales sin commitear",
        },
        forceUpdate: {
          title: "Actualización Forzada",
          description: "• Ignora cambios locales no críticos (logs, builds, archivos multimedia)",
          description2: "• Útil cuando hay archivos generados automáticamente",
          description3: "• Solo usar cuando sea necesario",
          button: "Forzar Actualización Completa"
        },
      },
      // ✅ NUEVAS TRADUCCIONES PARA RECUPERACIÓN DE CONTRASEÑA
      forgetPassword: {
        title: "Recuperar Contraseña",
        form: {
          email: "Correo Electrónico",
          token: "Código de Verificación",
          newPassword: "Nueva Contraseña",
          confirmPassword: "Confirmar Contraseña",
        },
        buttons: {
          sendEmail: "ENVIAR EMAIL",
          resetPassword: "RECUPERAR CONTRASEÑA",
        },
        messages: {
          emailSent: "Email enviado con éxito!",
          passwordReset: "Contraseña recuperada exitosamente.",
          emailNotFound: "Email no encontrado",
          passwordsNotMatch: "Las contraseñas no coinciden",
          passwordRequirements: "Tu contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula y un número.",
        },
        links: {
          noAccount: "¿No tienes una cuenta? ¡Regístrate!",
        },
        validation: {
          emailRequired: "El correo electrónico es obligatorio",
          invalidEmail: "Correo electrónico inválido",
          tokenRequired: "El código de verificación es obligatorio",
          passwordRequired: "La contraseña es obligatoria",
          confirmPasswordRequired: "La confirmación de contraseña es obligatoria",
        },
      },
      presence: {
        composing: "Escribiendo...",
        recording: "Grabando audio...",
      },
      languages: {
        "pt-BR": "Português",
        en: "English",
        es: "Español",
      },
    },
  },
};

export { messages };
